// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js!../node_modules/@fontsource/dm-sans/300.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/css-loader/dist/cjs.js!../node_modules/@fontsource/dm-sans/400.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../node_modules/css-loader/dist/cjs.js!../node_modules/@fontsource/dm-sans/500.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../node_modules/css-loader/dist/cjs.js!../node_modules/@fontsource/dm-sans/600.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../node_modules/css-loader/dist/cjs.js!../node_modules/@fontsource/dm-sans/700.css";
import ___CSS_LOADER_AT_RULE_IMPORT_5___ from "-!../node_modules/css-loader/dist/cjs.js!../node_modules/@fontsource/space-mono/400.css";
import ___CSS_LOADER_AT_RULE_IMPORT_6___ from "-!../node_modules/css-loader/dist/cjs.js!../node_modules/@fontsource/space-mono/700.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_5___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  color-scheme: dark;
  --demo-blue: #4f83ff;
  --demo-blue-bright: #77a3ff;
  --demo-ink: #020617;
  --demo-panel: #08101f;
  --demo-card: #0d1525;
  --demo-line: rgba(134, 155, 205, 0.22);
  --demo-soft: #98a7c6;
  --demo-white: #f7f9ff;
  --ds-font-family-base: "DM Sans";
  --ds-font-family-accent: "Space Mono";
}

html {
  min-width: 320px;
  min-height: 100%;
  scroll-behavior: smooth;
}

body {
  min-width: 320px;
  min-height: 100%;
  margin: 0;
  background:
    radial-gradient(circle at 50% -10%, rgba(28, 98, 235, 0.16), transparent 31rem),
    var(--demo-ink);
  color: var(--demo-white);
  font-family: var(--ds-font-family-base), system-ui, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

a {
  color: inherit;
  text-decoration: none;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

[data-slot="button"] {
  display: inline-flex;
  min-width: 40px;
  min-height: 40px;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: 0;
  border-radius: 8px;
  background: #1c62eb;
  color: white;
  padding: 9px 15px;
  font-size: 0.875rem;
  font-weight: 500;
  transition: background-color 160ms ease, border-color 160ms ease;
}

[data-slot="button"]:hover {
  background: #3373ef;
}

[data-slot="button"]:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

[data-slot="button"]:focus-visible {
  outline: 2px solid var(--demo-blue-bright);
  outline-offset: 2px;
}

[data-slot="button"] svg {
  width: 16px;
  height: 16px;
  flex: 0 0 auto;
}

[data-slot="badge"] {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  border: 1px solid #1c62eb;
  border-radius: 999px;
  background: rgba(28, 98, 235, 0.34);
  color: white;
  padding: 4px 10px 4px 8px;
  font-family: var(--ds-font-family-accent), monospace;
  font-size: 0.68rem;
  font-weight: 700;
}

button,
input,
select,
summary {
  font: inherit;
}

button,
select,
summary {
  touch-action: manipulation;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  margin: -1px;
  padding: 0;
  border: 0;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
}

.demo-shell {
  min-height: 100dvh;
}

.topbar {
  position: sticky;
  z-index: 50;
  top: 0;
  display: flex;
  min-height: 64px;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--demo-line);
  background: rgba(2, 6, 23, 0.92);
  padding: 0 28px;
  backdrop-filter: blur(18px);
}

.brand {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: var(--demo-white);
}

.brand:focus-visible {
  border-radius: 8px;
  outline: 2px solid var(--demo-blue-bright);
  outline-offset: 5px;
}

.brand__logo {
  display: block;
  flex: 0 0 auto;
}

.brand__divider {
  width: 1px;
  height: 20px;
  margin: 0 2px;
  background: var(--demo-line);
}

.brand__product {
  color: var(--demo-soft);
  font-family: var(--ds-font-family-accent), monospace;
  font-size: 0.67rem;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.topbar [data-slot="badge"] svg {
  width: 10px;
  height: 10px;
}

.site-nav {
  position: absolute;
  left: 50%;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px;
  border: 1px solid rgba(134, 155, 205, 0.16);
  border-radius: 999px;
  background: rgba(8, 16, 31, 0.78);
  transform: translateX(-50%);
}

.site-nav a {
  border-radius: 999px;
  color: var(--demo-soft);
  padding: 6px 12px;
  font-size: 0.73rem;
  font-weight: 600;
  transition: background-color 160ms ease, color 160ms ease;
}

.site-nav a:hover {
  color: white;
}

.site-nav a[aria-current="page"] {
  background: rgba(28, 98, 235, 0.28);
  color: white;
}

.site-nav a:focus-visible {
  outline: 2px solid var(--demo-blue-bright);
  outline-offset: 2px;
}

.demo-layout {
  display: grid;
  width: min(100%, 1400px);
  min-height: calc(100dvh - 64px);
  grid-template-columns: minmax(260px, 320px) minmax(400px, 480px) minmax(250px, 300px);
  align-items: start;
  justify-content: center;
  gap: clamp(24px, 3vw, 48px);
  margin: 0 auto;
  padding: 30px clamp(20px, 3vw, 48px) 80px;
}

.presenter-rail {
  position: sticky;
  top: 94px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.section-kicker {
  display: block;
  margin-bottom: 8px;
  color: var(--demo-blue-bright);
  font-family: var(--ds-font-family-accent), monospace;
  font-size: 0.67rem;
  font-weight: 700;
  letter-spacing: 0.13em;
  text-transform: uppercase;
}

.game-selector {
  padding: 4px 2px 0;
}

.game-selector h1,
.control-card h2,
.intelligence-card h2 {
  margin: 0;
  font-weight: 700;
  letter-spacing: -0.045em;
}

.game-selector h1 {
  max-width: 10ch;
  font-size: clamp(2rem, 3vw, 3rem);
  line-height: 0.98;
}

.game-selector > p,
.intelligence-card > p {
  margin: 14px 0 0;
  color: var(--demo-soft);
  font-size: 0.92rem;
  line-height: 1.55;
}

.game-selector__options {
  display: grid;
  gap: 8px;
  margin-top: 22px;
}

.game-selector__options button {
  position: relative;
  display: grid;
  width: 100%;
  gap: 2px;
  overflow: hidden;
  border: 1px solid var(--demo-line);
  border-radius: 10px;
  background: rgba(8, 16, 31, 0.68);
  color: var(--demo-white);
  padding: 14px 15px 14px 44px;
  text-align: left;
  transition:
    border-color 180ms ease,
    background-color 180ms ease,
    transform 180ms ease;
}

.game-selector__options button::before {
  position: absolute;
  top: 16px;
  left: 15px;
  width: 12px;
  height: 12px;
  border: 1px solid rgba(152, 167, 198, 0.6);
  border-radius: 50%;
  content: "";
  transition: 180ms ease;
}

.game-selector__options button:hover {
  border-color: rgba(119, 163, 255, 0.5);
  background: rgba(28, 98, 235, 0.08);
  transform: translateY(-1px);
}

.game-selector__options button:focus-visible {
  outline: 2px solid var(--demo-blue-bright);
  outline-offset: 2px;
}

.game-selector__options button.is-selected {
  border-color: rgba(79, 131, 255, 0.7);
  background: rgba(28, 98, 235, 0.14);
}

.game-selector__options button.is-selected::before {
  border: 3px solid #a9c4ff;
  background: var(--demo-blue);
  box-shadow: 0 0 0 4px rgba(79, 131, 255, 0.14);
}

.game-selector__options button > span {
  color: var(--demo-blue-bright);
  font-family: var(--ds-font-family-accent), monospace;
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.08em;
}

.game-selector__options button strong {
  font-size: 0.9rem;
  line-height: 1.35;
}

.game-selector__options button small {
  color: var(--demo-soft);
  font-size: 0.7rem;
}

.storypilot-game-link {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  margin-top: 14px;
  color: #c9d8ff;
  font-size: 0.76rem;
  font-weight: 600;
}

.storypilot-game-link:hover {
  color: white;
}

.storypilot-game-link:focus-visible {
  border-radius: 5px;
  outline: 2px solid var(--demo-blue-bright);
  outline-offset: 4px;
}

.storypilot-game-link svg {
  width: 14px;
  height: 14px;
}

.control-card,
.intelligence-card {
  border: 1px solid var(--demo-line);
  border-radius: 12px;
  background: rgba(8, 16, 31, 0.74);
  box-shadow: 0 18px 55px rgba(0, 0, 0, 0.18);
}

.control-card {
  padding: 17px;
}

.control-card__heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.control-card h2 {
  max-width: 13ch;
  font-size: 1.15rem;
  line-height: 1.1;
}

.status-dot {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--demo-soft);
  font-family: var(--ds-font-family-accent), monospace;
  font-size: 0.58rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.status-dot::before {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #66728d;
  content: "";
}

.status-dot--playing::before {
  background: #36d27e;
  box-shadow: 0 0 0 4px rgba(54, 210, 126, 0.12);
}

.status-dot--complete::before {
  background: var(--demo-blue-bright);
}

.transport-controls {
  display: grid;
  grid-template-columns: 40px 1fr;
  gap: 8px;
  margin-top: 18px;
}

.transport-controls [data-slot="button"] {
  width: 100%;
}

.transport-controls [data-slot="button"]:first-child {
  border: 1px solid var(--demo-line);
  background: transparent;
}

.transport-controls [data-slot="button"]:first-child:hover {
  background: rgba(134, 155, 205, 0.12);
}

.transport-controls__primary {
  box-shadow: 0 8px 24px rgba(28, 98, 235, 0.24);
}

.replay-scrubber {
  display: grid;
  gap: 9px;
  margin-top: 18px;
}

.replay-scrubber > span,
.rate-control {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  color: var(--demo-soft);
  font-family: var(--ds-font-family-accent), monospace;
  font-size: 0.62rem;
  letter-spacing: 0.04em;
}

.replay-scrubber output {
  color: var(--demo-white);
  font-variant-numeric: tabular-nums;
}

.replay-scrubber input {
  width: 100%;
  height: 16px;
  margin: 0;
  appearance: none;
  background: transparent;
  cursor: pointer;
}

.replay-scrubber input::-webkit-slider-runnable-track {
  height: 4px;
  border-radius: 4px;
  background: linear-gradient(
    to right,
    var(--demo-blue) 0 var(--scrub-progress),
    rgba(134, 155, 205, 0.22) var(--scrub-progress) 100%
  );
}

.replay-scrubber input::-moz-range-track {
  height: 4px;
  border-radius: 4px;
  background: rgba(134, 155, 205, 0.22);
}

.replay-scrubber input::-moz-range-progress {
  height: 4px;
  border-radius: 4px;
  background: var(--demo-blue);
}

.replay-scrubber input::-webkit-slider-thumb {
  width: 14px;
  height: 14px;
  margin-top: -5px;
  appearance: none;
  border: 3px solid var(--demo-white);
  border-radius: 50%;
  background: var(--demo-blue);
  box-shadow: 0 0 0 3px rgba(79, 131, 255, 0.15);
}

.replay-scrubber input::-moz-range-thumb {
  width: 10px;
  height: 10px;
  border: 3px solid var(--demo-white);
  border-radius: 50%;
  background: var(--demo-blue);
}

.replay-scrubber input:focus-visible {
  outline: 2px solid var(--demo-blue-bright);
  outline-offset: 4px;
}

.rate-control {
  margin-top: 15px;
}

.rate-control > div {
  display: inline-flex;
  gap: 2px;
  padding: 2px;
  border: 1px solid var(--demo-line);
  border-radius: 7px;
}

.rate-control button {
  min-width: 34px;
  border: 0;
  border-radius: 5px;
  background: transparent;
  color: var(--demo-soft);
  padding: 4px 6px;
  font-family: var(--ds-font-family-accent), monospace;
  font-size: 0.61rem;
}

.rate-control button[aria-pressed="true"] {
  background: var(--demo-blue);
  color: white;
}

.rate-control button:focus-visible {
  outline: 2px solid var(--demo-blue-bright);
  outline-offset: 1px;
}

.feed-stage {
  min-width: 0;
}

.feed-stage__label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin: 0 4px 10px;
  color: var(--demo-soft);
  font-family: var(--ds-font-family-accent), monospace;
  font-size: 0.59rem;
  letter-spacing: 0.07em;
  text-transform: uppercase;
}

.feed-stage__label span:first-child {
  color: var(--demo-blue-bright);
  font-weight: 700;
}

.game-phone {
  position: relative;
  display: flex;
  width: 100%;
  height: 760px;
  overflow: hidden;
  flex-direction: column;
  border: 1px solid rgba(134, 155, 205, 0.34);
  border-radius: 26px;
  background: #070b14;
  box-shadow:
    0 40px 100px rgba(0, 0, 0, 0.45),
    0 0 0 6px rgba(255, 255, 255, 0.018);
}

.game-phone__header {
  position: relative;
  z-index: 20;
  flex: 0 0 auto;
  border-bottom: 1px solid rgba(134, 155, 205, 0.16);
  background: rgba(7, 11, 20, 0.94);
  backdrop-filter: blur(16px);
}

.game-phone__competition {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 17px 20px 0;
  color: #b8c4dc;
  font-family: var(--ds-font-family-accent), monospace;
  font-size: 0.6rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.game-phone__live {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: #68e79f;
}

.game-phone__live svg {
  width: 11px;
  height: 11px;
}

.scoreboard {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 14px;
  padding: 15px 20px 14px;
}

.team-score {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 10px;
}

.team-score--right {
  flex-direction: row-reverse;
  text-align: right;
}

.team-score__mark {
  display: grid;
  width: 38px;
  height: 38px;
  flex: 0 0 auto;
  place-items: center;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 10px;
  font-family: var(--ds-font-family-accent), monospace;
  font-size: 0.58rem;
  font-weight: 700;
  letter-spacing: -0.03em;
}

.team-score__identity {
  display: grid;
  min-width: 0;
  gap: 1px;
}

.team-score__identity span {
  overflow: hidden;
  color: var(--demo-soft);
  font-size: 0.68rem;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.team-score__identity strong {
  font-family: var(--ds-font-family-accent), monospace;
  font-size: 1.65rem;
  line-height: 1;
  font-variant-numeric: tabular-nums;
  letter-spacing: -0.08em;
}

.scoreboard__clock {
  display: grid;
  min-width: 62px;
  gap: 3px;
  color: var(--demo-soft);
  text-align: center;
}

.scoreboard__clock span {
  font-size: 0.61rem;
  font-weight: 700;
  text-transform: uppercase;
}

.scoreboard__clock strong {
  color: var(--demo-white);
  font-family: var(--ds-font-family-accent), monospace;
  font-size: 0.74rem;
  font-variant-numeric: tabular-nums;
}

.game-phone__beat {
  display: flex;
  min-height: 34px;
  align-items: center;
  border-top: 1px solid rgba(134, 155, 205, 0.1);
  padding: 8px 20px;
  color: #c9d3e8;
  font-size: 0.71rem;
  line-height: 1.35;
}

.game-phone__beat::before {
  width: 5px;
  height: 5px;
  flex: 0 0 auto;
  margin-right: 8px;
  border-radius: 50%;
  background: var(--demo-blue-bright);
  box-shadow: 0 0 0 4px rgba(79, 131, 255, 0.12);
  content: "";
}

.game-phone__progress {
  height: 2px;
  overflow: hidden;
  background: rgba(134, 155, 205, 0.1);
}

.game-phone__progress span {
  display: block;
  height: 100%;
  background: var(--demo-blue);
  box-shadow: 0 0 10px rgba(79, 131, 255, 0.7);
  transition: width 90ms linear;
}

.game-phone__mobile-controls {
  display: none;
}

.mobile-game-controls {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 8px;
}

.mobile-game-controls__game {
  position: relative;
  display: grid;
  min-width: 0;
  min-height: 48px;
  border: 1px solid rgba(134, 155, 205, 0.28);
  border-radius: 10px;
  background: rgba(2, 6, 23, 0.52);
}

.mobile-game-controls__game > span {
  position: absolute;
  z-index: 1;
  top: 6px;
  left: 12px;
  color: var(--demo-blue-bright);
  font-family: var(--ds-font-family-accent), monospace;
  font-size: 0.5rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  pointer-events: none;
}

.mobile-game-controls__game select {
  width: 100%;
  min-width: 0;
  min-height: 46px;
  appearance: none;
  overflow: hidden;
  border: 0;
  border-radius: inherit;
  outline: 0;
  background: transparent;
  color: var(--demo-white);
  padding: 17px 36px 3px 11px;
  font-size: 0.77rem;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}

.mobile-game-controls__game:focus-within {
  outline: 2px solid var(--demo-blue-bright);
  outline-offset: 2px;
}

.mobile-game-controls__game > svg {
  position: absolute;
  top: 50%;
  right: 11px;
  width: 16px;
  height: 16px;
  color: var(--demo-soft);
  pointer-events: none;
  transform: translateY(-50%);
}

.mobile-game-controls__primary[data-slot="button"] {
  min-width: 96px;
  min-height: 48px;
}

.mobile-game-controls__details {
  min-width: 0;
  grid-column: 1 / -1;
  border: 1px solid rgba(134, 155, 205, 0.22);
  border-radius: 10px;
  background: rgba(2, 6, 23, 0.42);
}

.mobile-game-controls__details summary {
  display: flex;
  min-height: 44px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-radius: inherit;
  color: #c9d3e8;
  padding: 0 12px;
  font-family: var(--ds-font-family-accent), monospace;
  font-size: 0.62rem;
  cursor: pointer;
  list-style: none;
}

.mobile-game-controls__details summary::-webkit-details-marker {
  display: none;
}

.mobile-game-controls__details summary:focus-visible {
  outline: 2px solid var(--demo-blue-bright);
  outline-offset: 2px;
}

.mobile-game-controls__details summary > span {
  display: inline-flex;
  align-items: center;
  gap: 7px;
}

.mobile-game-controls__details summary svg {
  width: 15px;
  height: 15px;
}

.mobile-game-controls__details summary > span:last-child svg {
  transition: transform 160ms ease;
}

.mobile-game-controls__details[open] summary {
  border-bottom: 1px solid rgba(134, 155, 205, 0.18);
  border-radius: 10px 10px 0 0;
}

.mobile-game-controls__details[open] summary > span:last-child svg {
  transform: rotate(180deg);
}

.mobile-game-controls__panel {
  padding: 13px 12px 12px;
}

.mobile-game-controls__status {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.mobile-game-controls__status .section-kicker {
  margin: 0;
}

.mobile-game-controls__panel .replay-scrubber {
  margin-top: 13px;
}

.mobile-game-controls__panel .replay-scrubber input {
  height: 44px;
}

.mobile-game-controls__panel .rate-control button {
  min-width: 44px;
  min-height: 44px;
}

.mobile-game-controls__actions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin-top: 13px;
}

.mobile-game-controls__actions [data-slot="button"] {
  min-height: 44px;
  border: 1px solid var(--demo-line);
  background: rgba(134, 155, 205, 0.08);
}

.mobile-game-controls__actions a {
  display: inline-flex;
  min-height: 44px;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: 1px solid var(--demo-line);
  border-radius: 8px;
  color: #c9d8ff;
  padding: 8px 10px;
  font-size: 0.7rem;
  font-weight: 700;
  text-align: center;
}

.mobile-game-controls__actions a:focus-visible {
  outline: 2px solid var(--demo-blue-bright);
  outline-offset: 2px;
}

.mobile-game-controls__actions a svg {
  width: 14px;
  height: 14px;
  flex: 0 0 auto;
}

.game-phone__updates {
  z-index: 18;
  flex: 0 0 auto;
  border-bottom: 1px solid rgba(119, 163, 255, 0.2);
  background: rgba(8, 16, 31, 0.96);
  padding: 8px 12px;
}

.game-phone__updates button {
  display: flex;
  width: 100%;
  min-height: 44px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 1px solid rgba(119, 163, 255, 0.38);
  border-radius: 999px;
  background: rgba(28, 98, 235, 0.16);
  color: #e9efff;
  padding: 8px 14px;
  font-size: 0.72rem;
  cursor: pointer;
}

.game-phone__updates button:hover {
  border-color: rgba(119, 163, 255, 0.68);
  background: rgba(28, 98, 235, 0.28);
}

.game-phone__updates button:focus-visible {
  outline: 2px solid var(--demo-blue-bright);
  outline-offset: 2px;
}

.game-phone__updates button svg {
  width: 15px;
  height: 15px;
}

.game-phone__updates button strong {
  color: var(--demo-blue-bright);
  font-family: var(--ds-font-family-accent), monospace;
  font-size: 0.6rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.game-feed {
  display: flex;
  min-height: 0;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 12px;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  overflow-anchor: none;
  padding: 14px;
  scrollbar-color: rgba(134, 155, 205, 0.35) transparent;
  scrollbar-width: thin;
  touch-action: pan-y;
  -webkit-overflow-scrolling: touch;
}

.game-feed__waiting {
  display: grid;
  min-height: 420px;
  place-content: center;
  justify-items: center;
  gap: 18px;
  color: var(--demo-soft);
  font-size: 0.8rem;
}

.game-feed__waiting-orbit {
  position: relative;
  width: 42px;
  height: 42px;
  border: 1px solid rgba(79, 131, 255, 0.5);
  border-radius: 50%;
}

.game-feed__waiting-orbit::before {
  position: absolute;
  inset: 9px;
  border: 1px solid var(--demo-blue);
  border-radius: 50%;
  content: "";
}

.game-feed__waiting-orbit::after {
  position: absolute;
  top: -3px;
  left: 18px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--demo-blue-bright);
  box-shadow: 0 0 14px rgba(79, 131, 255, 0.9);
  content: "";
  animation: orbit 2.2s linear infinite;
  transform-origin: 3px 24px;
}

.feed-card {
  --asset-accent: var(--demo-blue);
  position: relative;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
  flex: 0 0 auto;
  border: 1px solid rgba(134, 155, 205, 0.18);
  border-radius: 18px;
  background: var(--demo-card);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.19);
  animation: card-enter 460ms cubic-bezier(0.22, 1, 0.36, 1) both;
  will-change: transform, opacity;
}

.feed-card::after {
  position: absolute;
  inset: 0;
  border-radius: inherit;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);
  content: "";
  pointer-events: none;
}

.feed-card__media {
  position: relative;
  height: 210px;
  overflow: hidden;
  background: #10182a;
}

.feed-card__media--landscape,
.feed-card__media--square,
.feed-card__media--portrait {
  height: auto;
}

.feed-card__media--landscape {
  aspect-ratio: 16 / 9;
}

.feed-card__media--square {
  aspect-ratio: 1;
}

.feed-card__media--portrait {
  aspect-ratio: 4 / 5;
}

.feed-card__media img,
.feed-card__media video {
  display: block;
  width: 100%;
  height: 100%;
  max-width: 100%;
  object-fit: cover;
}

.feed-card__media img {
  transition: transform 900ms cubic-bezier(0.22, 1, 0.36, 1);
}

.feed-card:hover .feed-card__media img {
  transform: scale(1.025);
}

.storyteller-clip,
.storyteller-story {
  position: relative;
  width: 100%;
  max-width: 100%;
  aspect-ratio: 9 / 16;
  overflow: hidden;
  background: #060a13;
  isolation: isolate;
}

.storyteller-clip__poster,
.storyteller-story__launcher > img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.storyteller-clip__poster {
  position: absolute;
  z-index: 0;
  inset: 0;
  transition: opacity 180ms ease;
}

.storyteller-clip[data-load-state="ready"] .storyteller-clip__poster {
  opacity: 0;
}

.storyteller-clip__mount {
  position: absolute;
  z-index: 1;
  inset: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.storyteller-clip__mount > * {
  width: 100% !important;
  height: 100% !important;
  max-width: 100% !important;
}

.storyteller-clip__status {
  position: absolute;
  z-index: 3;
  right: 14px;
  bottom: 14px;
  left: 14px;
  display: flex;
  min-height: 48px;
  align-items: center;
  justify-content: center;
  gap: 9px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  background: rgba(3, 7, 18, 0.84);
  color: white;
  padding: 10px 12px;
  font-family: var(--ds-font-family-accent), monospace;
  font-size: 0.62rem;
  letter-spacing: 0.035em;
  text-transform: uppercase;
  backdrop-filter: blur(12px);
}

.storyteller-clip__status--error {
  justify-content: space-between;
}

.storyteller-clip__status button {
  display: inline-flex;
  min-height: 44px;
  align-items: center;
  gap: 7px;
  border: 1px solid rgba(255, 255, 255, 0.28);
  border-radius: 9px;
  background: rgba(28, 98, 235, 0.78);
  color: white;
  padding: 8px 11px;
  font: inherit;
  cursor: pointer;
}

.storyteller-clip__status button:focus-visible,
.storyteller-story__launcher:focus-visible {
  outline: 2px solid white;
  outline-offset: -4px;
}

.storyteller-clip__status button svg {
  width: 15px;
  height: 15px;
}

.storyteller-clip__spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.26);
  border-top-color: white;
  border-radius: 50%;
  animation: storyteller-spin 800ms linear infinite;
}

.storyteller-story__launcher {
  position: absolute;
  inset: 0;
  display: block;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border: 0;
  background: #060a13;
  color: white;
  padding: 0;
  text-align: left;
  cursor: pointer;
}

.storyteller-story__launcher > img {
  transition: transform 700ms cubic-bezier(0.22, 1, 0.36, 1);
}

.storyteller-story__launcher:hover > img {
  transform: scale(1.025);
}

.storyteller-story__shade {
  position: absolute;
  inset: 0;
  background:
    linear-gradient(to bottom, rgba(4, 8, 18, 0.08) 40%, rgba(4, 8, 18, 0.88)),
    linear-gradient(to right, rgba(4, 8, 18, 0.26), transparent 62%);
}

.storyteller-story__play {
  position: absolute;
  top: 50%;
  left: 50%;
  display: grid;
  width: 62px;
  height: 62px;
  place-items: center;
  border: 1px solid rgba(255, 255, 255, 0.72);
  border-radius: 50%;
  background: rgba(3, 7, 18, 0.46);
  box-shadow: 0 16px 34px rgba(0, 0, 0, 0.34);
  transform: translate(-50%, -50%);
  backdrop-filter: blur(10px);
}

.storyteller-story__play svg {
  width: 30px;
  height: 30px;
}

.storyteller-story__copy {
  position: absolute;
  right: 18px;
  bottom: 18px;
  left: 18px;
  display: grid;
  gap: 5px;
}

.storyteller-story__copy small {
  color: rgba(255, 255, 255, 0.72);
  font-family: var(--ds-font-family-accent), monospace;
  font-size: 0.58rem;
  letter-spacing: 0.07em;
  text-transform: uppercase;
}

.storyteller-story__copy strong {
  max-width: 16ch;
  font-size: 1.26rem;
  line-height: 1.08;
  letter-spacing: -0.035em;
}

.feed-card--insight .feed-card__media {
  height: 168px;
}

.feed-card--moment .feed-card__media {
  height: 245px;
}

.feed-card--moment .feed-card__media img {
  object-position: center 26%;
}

.feed-card--recap .feed-card__media,
.feed-card--highlight .feed-card__media {
  height: 230px;
}

.feed-card__gallery {
  position: relative;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 2px;
  overflow: hidden;
  background: rgba(134, 155, 205, 0.18);
}

.feed-card__gallery figure {
  position: relative;
  aspect-ratio: 1;
  margin: 0;
  overflow: hidden;
  background: #10182a;
}

.feed-card__gallery:has(figure:nth-child(3):last-child) figure:first-child {
  grid-column: 1 / -1;
  aspect-ratio: 2 / 1;
}

.feed-card__gallery img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 900ms cubic-bezier(0.22, 1, 0.36, 1);
}

.feed-card--gallery:hover .feed-card__gallery img {
  transform: scale(1.025);
}

.feed-card__gallery-credit {
  position: absolute;
  right: 8px;
  bottom: 8px;
  padding: 4px 6px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 999px;
  background: rgba(3, 7, 18, 0.76);
  color: rgba(255, 255, 255, 0.78);
  font-family: var(--ds-font-family-accent), monospace;
  font-size: 0.47rem;
  letter-spacing: 0.045em;
  text-transform: uppercase;
  backdrop-filter: blur(8px);
}

.feed-card .feed-card__media--landscape,
.feed-card .feed-card__media--square,
.feed-card .feed-card__media--portrait {
  height: auto;
}

.feed-source {
  position: relative;
  z-index: 2;
}

.feed-source--social {
  display: grid;
  gap: 11px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  background:
    radial-gradient(circle at top right, rgba(255, 255, 255, 0.08), transparent 34%),
    #080d17;
  padding: 16px 17px 15px;
}

.feed-source__identity {
  display: grid;
  grid-template-columns: 34px minmax(0, 1fr) auto;
  align-items: center;
  gap: 10px;
}

.feed-source__platform {
  display: grid;
  width: 34px;
  height: 34px;
  place-items: center;
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 50%;
  background: white;
  color: #05070b;
  font-family: var(--ds-font-family-accent), monospace;
  font-size: 0.82rem;
  font-weight: 800;
}

.feed-source__account {
  display: grid;
  min-width: 0;
  gap: 1px;
}

.feed-source__account strong {
  overflow: hidden;
  color: white;
  font-size: 0.78rem;
  line-height: 1.15;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.feed-source__account span,
.feed-source__identity time {
  color: #8997b2;
  font-family: var(--ds-font-family-accent), monospace;
  font-size: 0.53rem;
  letter-spacing: 0.02em;
}

.feed-source__identity time {
  text-align: right;
}

.feed-source p.feed-source__post-copy {
  margin: 0;
  color: #edf2fd;
  font-size: 0.84rem;
  line-height: 1.48;
  overflow-wrap: anywhere;
  white-space: pre-line;
}

.feed-source__link {
  display: inline-flex;
  width: fit-content;
  align-items: center;
  gap: 5px;
  color: #8cb1ff;
  font-size: 0.64rem;
  font-weight: 700;
  text-decoration: none;
}

.feed-source__link:hover {
  color: white;
}

.feed-source__link:focus-visible,
.feed-source__getty-credit:focus-visible {
  border-radius: 5px;
  outline: 2px solid var(--demo-blue-bright);
  outline-offset: 3px;
}

.feed-source__link svg,
.feed-source__getty-credit svg {
  width: 13px;
  height: 13px;
  flex: 0 0 auto;
}

.feed-source__getty-credit {
  position: relative;
  z-index: 3;
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 7px;
  border-top: 1px solid rgba(134, 155, 205, 0.14);
  border-bottom: 1px solid rgba(134, 155, 205, 0.14);
  background: #080e1a;
  color: #b9c4d9;
  padding: 8px 12px;
  font-family: var(--ds-font-family-accent), monospace;
  font-size: 0.48rem;
  line-height: 1.35;
  letter-spacing: 0.025em;
  text-decoration: none;
}

.feed-source__getty-credit > span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.feed-source__getty-credit small {
  margin-left: auto;
  border: 1px solid rgba(255, 255, 255, 0.13);
  border-radius: 999px;
  color: #d7deec;
  padding: 2px 5px;
  font: inherit;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.feed-source__getty-credit:hover {
  color: white;
}

.feed-source__getty-credit--compact {
  position: absolute;
  right: 5px;
  bottom: 5px;
  left: 5px;
  gap: 4px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 6px;
  background: rgba(3, 7, 18, 0.78);
  color: rgba(255, 255, 255, 0.85);
  padding: 4px 5px;
  font-size: 0.4rem;
  backdrop-filter: blur(8px);
}

.feed-source__getty-credit--compact svg {
  width: 9px;
  height: 9px;
}

.feed-card--source-official-social {
  border-color: rgba(255, 255, 255, 0.2);
}

.feed-card--source-official-social .feed-card__content {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.035), transparent 58%);
}

.feed-card__media-wash {
  position: absolute;
  inset: auto 0 0;
  height: 55%;
  background: linear-gradient(to bottom, transparent, rgba(7, 11, 20, 0.68));
  pointer-events: none;
}

.feed-card__play {
  position: absolute;
  z-index: 2;
  inset: 50% auto auto 50%;
  display: grid;
  width: 58px;
  height: 58px;
  place-items: center;
  border: 1px solid rgba(255, 255, 255, 0.7);
  border-radius: 50%;
  background: rgba(2, 6, 23, 0.52);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.35);
  backdrop-filter: blur(8px);
  cursor: pointer;
  transform: translate(-50%, -50%);
  transition: background-color 160ms ease, transform 160ms ease;
}

.feed-card__play:hover {
  background: rgba(28, 98, 235, 0.76);
  transform: translate(-50%, -50%) scale(1.04);
}

.feed-card__play:focus-visible {
  outline: 2px solid white;
  outline-offset: 3px;
}

.feed-card__play svg {
  width: 29px;
  height: 29px;
  color: white;
}

.feed-card__content {
  position: relative;
  z-index: 2;
  min-width: 0;
  padding: 17px;
  overflow-wrap: anywhere;
}

.feed-card--has-image .feed-card__content {
  border-top: 1px solid rgba(134, 155, 205, 0.16);
}

.feed-card__meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 11px;
  color: var(--demo-soft);
  font-family: var(--ds-font-family-accent), monospace;
  font-size: 0.58rem;
  letter-spacing: 0.045em;
  text-transform: uppercase;
}

.feed-card__meta > span {
  min-width: 0;
}

.feed-card__meta > span:last-child {
  text-align: right;
}

.feed-card__label {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: color-mix(in srgb, var(--asset-accent) 78%, white);
  font-weight: 700;
}

.feed-card__label svg {
  width: 11px;
  height: 11px;
}

.feed-card h3 {
  max-width: 20ch;
  margin: 0;
  color: white;
  font-size: clamp(1.22rem, 4vw, 1.58rem);
  line-height: 1.05;
  letter-spacing: -0.045em;
}

.feed-card p {
  margin: 10px 0 0;
  color: #b7c2d9;
  font-size: 0.84rem;
  line-height: 1.5;
}

.feed-data-visual {
  margin-top: 16px;
  overflow: hidden;
  border: 1px solid rgba(134, 155, 205, 0.22);
  border-radius: 14px;
  background:
    radial-gradient(circle at 85% 0, color-mix(in srgb, var(--asset-accent) 17%, transparent), transparent 42%),
    #080f1d;
  animation: feed-visual-in 460ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.feed-data-visual figure,
.feed-data-visual section {
  margin: 0;
}

.court-moment {
  padding: 14px;
}

.court-moment figcaption,
.game-flow figcaption,
.lineup-stint__heading,
.tracking-shot-profile__heading,
.api-insight__heading {
  display: grid;
  gap: 3px;
  margin-bottom: 12px;
}

.court-moment figcaption span,
.game-flow figcaption span,
.lineup-stint__heading span,
.tracking-shot-profile__heading span,
.api-insight__heading span {
  color: color-mix(in srgb, var(--asset-accent) 76%, white);
  font-family: var(--ds-font-family-accent), monospace;
  font-size: 0.52rem;
  font-weight: 700;
  letter-spacing: 0.085em;
}

.court-moment figcaption strong,
.game-flow figcaption strong,
.lineup-stint__heading strong,
.tracking-shot-profile__heading strong,
.api-insight__heading strong {
  color: white;
  font-size: 0.92rem;
  line-height: 1.2;
  letter-spacing: -0.025em;
}

.court-moment svg,
.game-flow svg {
  display: block;
  width: 100%;
  height: auto;
  overflow: visible;
}

.court-moment__sequence {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  row-gap: 12px;
  margin: 0 0 12px;
  padding: 0;
  list-style: none;
}

.court-moment__sequence li {
  position: relative;
  display: grid;
  grid-template-rows: auto 10px auto;
  gap: 4px;
  min-width: 0;
  color: #aebbd1;
  font-family: var(--ds-font-family-accent), monospace;
  font-size: 0.56rem;
  line-height: 1.25;
  text-transform: uppercase;
}

.court-moment__sequence li::after {
  position: absolute;
  top: 19px;
  right: 0;
  left: 7px;
  height: 1px;
  background: rgba(255, 255, 255, 0.16);
  content: "";
}

.court-moment__sequence li:last-child::after {
  display: none;
}

.court-moment__sequence li:nth-child(3n)::after {
  display: none;
}

.court-moment__sequence time {
  color: white;
  font-weight: 700;
}

.court-moment__sequence i {
  z-index: 1;
  width: 9px;
  height: 9px;
  border: 2px solid #8f9db6;
  border-radius: 50%;
  background: #080f1d;
}

.court-moment__sequence li[data-tone="defense"] i {
  border-color: #6eb7ff;
  background: #0d4676;
}

.court-moment__sequence li[data-tone="score"] i {
  border-color: color-mix(in srgb, var(--asset-accent) 78%, white);
  background: color-mix(in srgb, var(--asset-accent) 62%, #080f1d);
}

.court-moment__sequence span {
  padding-right: 5px;
}

.court-moment__floor {
  fill: #152235;
  stroke: rgba(255, 255, 255, 0.12);
  stroke-width: 3;
}

.court-moment__line {
  fill: none;
  stroke: rgba(220, 231, 250, 0.26);
  stroke-width: 3;
}

.court-moment__backboard {
  stroke: rgba(255, 255, 255, 0.86);
  stroke-width: 5;
}

.court-moment__rim {
  fill: none;
  stroke: #ff7a45;
  stroke-width: 5;
}

.court-moment__shot {
  color: #c7d1e4;
}

.court-moment__shot path {
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-width: 6;
}

.court-moment__shot circle {
  fill: color-mix(in srgb, var(--asset-accent) 78%, #ff7a45);
  stroke: white;
  stroke-width: 3;
}

.court-moment__shot circle.court-moment__shot-core {
  fill: white;
  stroke: none;
}

.court-moment__shot text {
  fill: #c7d1e4;
  font-family: var(--ds-font-family-accent), monospace;
  font-size: 17px;
  font-weight: 700;
  letter-spacing: 0.03em;
  paint-order: stroke;
  stroke: #152235;
  stroke-width: 7px;
  stroke-linejoin: round;
}

.court-moment__shot text.court-moment__hero-label {
  fill: white;
  font-size: 19px;
  letter-spacing: 0.065em;
}

.court-moment__key {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 8px;
  color: #9eabc2;
  font-family: var(--ds-font-family-accent), monospace;
  font-size: 0.51rem;
  letter-spacing: 0.035em;
  text-transform: uppercase;
}

.court-moment__key span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.court-moment__key i {
  display: inline-block;
  width: 9px;
  height: 9px;
}

.court-moment__key-miss {
  position: relative;
}

.court-moment__key-miss::before,
.court-moment__key-miss::after {
  position: absolute;
  top: 4px;
  left: 0;
  width: 10px;
  height: 1px;
  background: #c7d1e4;
  content: "";
  transform: rotate(45deg);
}

.court-moment__key-miss::after {
  transform: rotate(-45deg);
}

.court-moment__key-make {
  border: 2px solid white;
  border-radius: 50%;
  background: color-mix(in srgb, var(--asset-accent) 78%, #ff7a45);
}

.game-flow {
  padding: 14px 14px 12px;
}

.game-flow__quarter {
  stroke: rgba(255, 255, 255, 0.08);
  stroke-dasharray: 3 4;
}

.game-flow__zero {
  stroke: rgba(255, 255, 255, 0.4);
  stroke-width: 1.5;
}

.game-flow__area {
  opacity: 0.78;
}

.game-flow__path {
  fill: none;
  stroke: color-mix(in srgb, var(--asset-accent) 84%, white);
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 3;
}

.game-flow__team {
  fill: #8997b2;
  font-family: var(--ds-font-family-accent), monospace;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.08em;
}

.game-flow__annotation circle {
  fill: var(--asset-accent);
  stroke: white;
  stroke-width: 2;
}

.game-flow__receipts {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin-top: 7px;
  border-top: 1px solid rgba(134, 155, 205, 0.14);
}

.game-flow__receipts > div {
  display: grid;
  min-width: 0;
  gap: 2px;
  padding: 9px 6px 0;
  text-align: center;
}

.game-flow__receipts > div + div {
  border-left: 1px solid rgba(134, 155, 205, 0.14);
}

.game-flow__receipts span,
.game-flow__receipts small {
  overflow: hidden;
  color: #8f9db6;
  font-family: var(--ds-font-family-accent), monospace;
  font-size: 0.43rem;
  letter-spacing: 0.045em;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.game-flow__receipts strong {
  color: white;
  font-family: var(--ds-font-family-accent), monospace;
  font-size: 0.92rem;
}

.lineup-stint,
.tracking-shot-profile,
.api-insight {
  padding: 14px;
}

.lineup-stint__players {
  display: grid;
  gap: 5px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.lineup-stint__players li {
  display: grid;
  grid-template-columns: 25px minmax(0, 1fr);
  align-items: center;
  gap: 9px;
  color: #dbe3f2;
  font-size: 0.7rem;
}

.lineup-stint__players li span {
  display: grid;
  width: 25px;
  height: 25px;
  place-items: center;
  border: 1px solid color-mix(in srgb, var(--asset-accent) 42%, transparent);
  border-radius: 50%;
  background: color-mix(in srgb, var(--asset-accent) 13%, transparent);
  color: white;
  font-family: var(--ds-font-family-accent), monospace;
  font-size: 0.55rem;
  font-weight: 700;
}

.lineup-stint__stats,
.api-insight__facts {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  margin: 13px 0 0;
  border-top: 1px solid rgba(134, 155, 205, 0.14);
}

.lineup-stint__stats > div,
.api-insight__facts > div {
  display: grid;
  gap: 2px;
  padding: 9px 4px 0;
  text-align: center;
}

.lineup-stint__stats dd,
.lineup-stint__stats dt,
.api-insight__facts dd,
.api-insight__facts dt {
  margin: 0;
}

.lineup-stint__stats dd,
.api-insight__facts dd {
  color: white;
  font-family: var(--ds-font-family-accent), monospace;
  font-size: 0.82rem;
  font-weight: 700;
}

.lineup-stint__stats dt,
.api-insight__facts dt {
  color: #8593ad;
  font-family: var(--ds-font-family-accent), monospace;
  font-size: 0.43rem;
  letter-spacing: 0.075em;
}

.impact-receipt {
  display: grid;
  grid-template-columns: 108px minmax(0, 1fr);
  gap: 13px;
  padding: 14px;
}

.impact-receipt__hero {
  display: grid;
  align-content: center;
  border-right: 1px solid rgba(134, 155, 205, 0.18);
  padding-right: 13px;
}

.impact-receipt__hero span {
  color: #acb8cd;
  font-size: 0.61rem;
  line-height: 1.25;
}

.impact-receipt__hero strong {
  color: white;
  font-family: var(--ds-font-family-accent), monospace;
  font-size: 2.7rem;
  line-height: 0.98;
  letter-spacing: -0.08em;
}

.impact-receipt__hero small {
  color: color-mix(in srgb, var(--asset-accent) 76%, white);
  font-family: var(--ds-font-family-accent), monospace;
  font-size: 0.43rem;
  letter-spacing: 0.075em;
}

.impact-receipt__route {
  display: grid;
  gap: 6px;
}

.impact-receipt__route > div {
  display: grid;
  grid-template-columns: 8px 1fr auto;
  align-items: center;
  gap: 7px;
  color: #9eabc2;
  font-family: var(--ds-font-family-accent), monospace;
  font-size: 0.5rem;
}

.impact-receipt__route i {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--asset-accent);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--asset-accent) 16%, transparent);
}

.impact-receipt__route strong {
  color: white;
}

.impact-receipt p {
  grid-column: 1 / -1;
  margin-top: 0;
  font-size: 0.69rem;
}

.insight-receipt {
  padding: 14px;
}

.insight-receipt__heading,
.insight-receipt__footer,
.tracking-shot-profile__identity {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.insight-receipt__heading span,
.tracking-shot-profile__identity span {
  color: #b8c3d8;
  font-size: 0.66rem;
}

.insight-receipt__heading strong {
  color: white;
  font-family: var(--ds-font-family-accent), monospace;
  font-size: 1.25rem;
}

.insight-receipt__attempts {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 5px;
  margin: 11px 0;
}

.insight-receipt__attempts i {
  aspect-ratio: 1;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.04);
}

.insight-receipt__attempts i.is-made {
  border-color: color-mix(in srgb, var(--asset-accent) 72%, white);
  background: var(--asset-accent);
}

.insight-receipt__footer {
  color: #8f9db6;
  font-family: var(--ds-font-family-accent), monospace;
  font-size: 0.5rem;
  letter-spacing: 0.045em;
}

.insight-receipt__footer strong {
  color: white;
}

.tracking-shot-profile__players {
  display: grid;
  gap: 13px;
}

.tracking-shot-profile__identity {
  margin-bottom: 5px;
  font-family: var(--ds-font-family-accent), monospace;
  font-size: 0.51rem;
}

.tracking-shot-profile__identity strong {
  color: white;
  font-size: 0.56rem;
}

.tracking-shot-profile__bar {
  height: 9px;
  overflow: hidden;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.06);
}

.tracking-shot-profile__bar > i {
  display: block;
  height: 100%;
  overflow: hidden;
  border: 1px solid color-mix(in srgb, var(--profile-color) 48%, transparent);
  border-radius: inherit;
  background: color-mix(in srgb, var(--profile-color) 13%, transparent);
}

.tracking-shot-profile__bar span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: var(--profile-color);
}

.tracking-shot-profile > p,
.api-insight > p {
  margin-top: 12px;
  font-size: 0.69rem;
}

.api-insight__facts {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

@keyframes feed-visual-in {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.feed-card__stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  margin: 15px 0 0;
  border-top: 1px solid rgba(134, 155, 205, 0.14);
  border-bottom: 1px solid rgba(134, 155, 205, 0.14);
}

.feed-card__stats > div {
  display: grid;
  gap: 2px;
  padding: 11px 9px;
  text-align: center;
}

.feed-card__stats > div + div {
  border-left: 1px solid rgba(134, 155, 205, 0.14);
}

.feed-card__stats dd,
.feed-card__stats dt {
  margin: 0;
}

.feed-card__stats dd {
  color: white;
  font-family: var(--ds-font-family-accent), monospace;
  font-size: 1.05rem;
  font-weight: 700;
  letter-spacing: -0.04em;
}

.feed-card__stats dt {
  color: var(--demo-soft);
  font-family: var(--ds-font-family-accent), monospace;
  font-size: 0.52rem;
  letter-spacing: 0.08em;
}

.feed-card__caption {
  margin-top: 13px;
  border-left: 2px solid var(--asset-accent);
  color: #d4dcef;
  padding-left: 10px;
  font-size: 0.71rem;
  font-style: italic;
}

.feed-card__action {
  display: flex;
  min-height: 28px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 15px;
  color: white;
  font-size: 0.72rem;
  font-weight: 700;
}

.feed-card__action--button {
  width: 100%;
  border: 0;
  background: transparent;
  padding: 0;
  text-align: left;
  cursor: pointer;
}

.feed-card__action--button:hover > span:first-child {
  color: var(--demo-blue-bright);
}

.feed-card__action--button:focus-visible {
  border-radius: 5px;
  outline: 2px solid var(--demo-blue-bright);
  outline-offset: 4px;
}

.feed-card__action > span:first-child {
  display: inline-flex;
  align-items: center;
  gap: 7px;
}

.feed-card__action svg {
  width: 15px;
  height: 15px;
  color: color-mix(in srgb, var(--asset-accent) 78%, white);
}

.feed-card__duration {
  color: var(--demo-soft);
  font-family: var(--ds-font-family-accent), monospace;
  font-size: 0.6rem;
  font-weight: 400;
}

.feed-card--alert {
  border-color: color-mix(in srgb, var(--asset-accent) 45%, transparent);
  background:
    linear-gradient(100deg, color-mix(in srgb, var(--asset-accent) 18%, transparent), transparent 58%),
    var(--demo-card);
}

.feed-card--alert::before {
  position: absolute;
  inset: 0 auto 0 0;
  width: 3px;
  background: var(--asset-accent);
  content: "";
}

.feed-card--alert h3 {
  max-width: 18ch;
  font-size: 1.45rem;
}

.feed-card--catch-up {
  border-color: rgba(79, 131, 255, 0.36);
  background:
    linear-gradient(145deg, rgba(28, 98, 235, 0.18), transparent 62%),
    #0c1424;
}

.feed-card--recap {
  border-color: rgba(253, 185, 39, 0.3);
}

.feed-card--gallery {
  border-color: rgba(79, 131, 255, 0.34);
}

.feed-card--gallery .feed-card__content {
  border-top: 1px solid rgba(134, 155, 205, 0.16);
}

.feed-card--incoming {
  display: grid;
  min-height: 142px;
  grid-template-columns: 54px 1fr;
  align-items: center;
  gap: 14px;
  padding: 18px;
  border-color: rgba(79, 131, 255, 0.36);
  background: rgba(28, 98, 235, 0.08);
}

.incoming-signal {
  position: relative;
  display: grid;
  width: 52px;
  height: 52px;
  place-items: center;
}

.incoming-signal span {
  position: absolute;
  border: 1px solid rgba(119, 163, 255, 0.8);
  border-radius: 50%;
  animation: signal-pulse 1.25s ease-out infinite;
}

.incoming-signal span:nth-child(1) {
  width: 12px;
  height: 12px;
  background: var(--demo-blue);
}

.incoming-signal span:nth-child(2) {
  width: 30px;
  height: 30px;
  animation-delay: 120ms;
}

.incoming-signal span:nth-child(3) {
  width: 50px;
  height: 50px;
  animation-delay: 240ms;
}

.incoming-copy {
  display: grid;
  gap: 9px;
}

.skeleton-line {
  display: block;
  height: 9px;
  border-radius: 4px;
  background: linear-gradient(
    90deg,
    rgba(124, 145, 193, 0.12),
    rgba(119, 163, 255, 0.34),
    rgba(124, 145, 193, 0.12)
  );
  background-size: 220% 100%;
  animation: skeleton-shimmer 1.2s linear infinite;
}

.skeleton-line--eyebrow {
  width: 34%;
  height: 6px;
}

.skeleton-line--title {
  width: 88%;
  height: 15px;
}

.skeleton-line--body {
  width: 68%;
}

.intelligence-card {
  padding: 20px;
}

.intelligence-card h2 {
  max-width: 10ch;
  font-size: 1.6rem;
  line-height: 1.02;
}

.intelligence-card__now {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-top: 19px;
  border-top: 1px solid var(--demo-line);
  padding-top: 17px;
}

.intelligence-card__pulse {
  width: 8px;
  height: 8px;
  flex: 0 0 auto;
  margin-top: 5px;
  border-radius: 50%;
  background: #36d27e;
  box-shadow: 0 0 0 5px rgba(54, 210, 126, 0.1);
}

.intelligence-card__now div {
  display: grid;
  gap: 4px;
}

.intelligence-card__now small {
  color: var(--demo-soft);
  font-family: var(--ds-font-family-accent), monospace;
  font-size: 0.58rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.intelligence-card__now strong {
  color: #dbe4f7;
  font-size: 0.8rem;
  line-height: 1.42;
}

.capability-stack {
  display: grid;
  gap: 8px;
}

.capability {
  display: grid;
  grid-template-columns: 33px 1fr;
  gap: 10px;
  border: 1px solid rgba(134, 155, 205, 0.13);
  border-radius: 10px;
  background: rgba(8, 16, 31, 0.46);
  padding: 13px;
}

.capability > span {
  display: grid;
  width: 31px;
  height: 31px;
  place-items: center;
  border: 1px solid rgba(79, 131, 255, 0.26);
  border-radius: 8px;
  background: rgba(28, 98, 235, 0.1);
  color: var(--demo-blue-bright);
}

.capability svg {
  width: 15px;
  height: 15px;
}

.capability h3,
.capability p {
  margin: 0;
}

.capability h3 {
  font-size: 0.78rem;
}

.capability p {
  margin-top: 4px;
  color: var(--demo-soft);
  font-size: 0.7rem;
  line-height: 1.42;
}

.feed-items-shell {
  min-height: 100dvh;
}

.feed-items-hero {
  display: grid;
  width: min(100%, 1440px);
  grid-template-columns: minmax(0, 1fr) minmax(340px, 0.58fr);
  align-items: end;
  gap: clamp(40px, 8vw, 120px);
  margin: 0 auto;
  padding: clamp(68px, 8vw, 118px) clamp(24px, 5vw, 72px) clamp(72px, 9vw, 132px);
}

.feed-items-hero__copy {
  max-width: 780px;
}

.feed-items-hero h1 {
  max-width: 12ch;
  margin: 0;
  font-size: clamp(3.2rem, 7vw, 7rem);
  font-weight: 700;
  line-height: 0.9;
  letter-spacing: -0.065em;
}

.feed-items-hero__copy > p {
  max-width: 660px;
  margin: 26px 0 0;
  color: #b7c2d9;
  font-size: clamp(1rem, 1.6vw, 1.3rem);
  line-height: 1.55;
}

.feed-items-hero__link {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  margin-top: 28px;
  color: #dce6ff;
  font-size: 0.86rem;
  font-weight: 700;
}

.feed-items-hero__link:hover {
  color: white;
}

.feed-items-hero__link:focus-visible {
  border-radius: 6px;
  outline: 2px solid var(--demo-blue-bright);
  outline-offset: 5px;
}

.feed-items-hero__link svg {
  width: 17px;
  height: 17px;
}

.feed-items-hero__facts {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin: 0;
  border-top: 1px solid var(--demo-line);
  border-bottom: 1px solid var(--demo-line);
}

.feed-items-hero__facts > div {
  display: flex;
  flex-direction: column;
  min-width: 0;
  padding: 24px 14px;
  text-align: center;
}

.feed-items-hero__facts > div + div {
  border-left: 1px solid var(--demo-line);
}

.feed-items-hero__facts dd,
.feed-items-hero__facts dt {
  margin: 0;
}

.feed-items-hero__facts dd {
  order: -1;
  font-family: var(--ds-font-family-accent), monospace;
  font-size: clamp(1.5rem, 3vw, 2.5rem);
  font-weight: 700;
}

.feed-items-hero__facts dt {
  margin-top: 6px;
  color: var(--demo-soft);
  font-size: 0.68rem;
  line-height: 1.35;
}

.feed-items-sections {
  border-top: 1px solid var(--demo-line);
}

.feed-items-section {
  width: min(100%, 1440px);
  margin: 0 auto;
  padding: clamp(68px, 8vw, 112px) clamp(24px, 5vw, 72px);
}

.feed-items-section + .feed-items-section {
  border-top: 1px solid var(--demo-line);
}

.feed-items-section__header {
  display: grid;
  grid-template-columns: 58px minmax(0, 760px);
  gap: 24px;
  margin-bottom: clamp(48px, 7vw, 88px);
}

.feed-items-section__number {
  color: rgba(119, 163, 255, 0.58);
  font-family: var(--ds-font-family-accent), monospace;
  font-size: 0.78rem;
  letter-spacing: 0.12em;
}

.feed-items-section__header h2 {
  margin: 0;
  font-size: clamp(2.2rem, 4.7vw, 4.8rem);
  line-height: 0.96;
  letter-spacing: -0.055em;
}

.feed-items-section__header p {
  max-width: 680px;
  margin: 20px 0 0;
  color: var(--demo-soft);
  font-size: clamp(0.98rem, 1.5vw, 1.18rem);
  line-height: 1.58;
}

.feed-item-families {
  display: grid;
  gap: clamp(64px, 9vw, 120px);
}

.feed-item-family__header {
  display: grid;
  max-width: 760px;
  grid-template-columns: 42px minmax(0, 1fr);
  gap: 16px;
  margin-bottom: 30px;
}

.feed-item-family__header > span {
  display: grid;
  width: 42px;
  height: 42px;
  place-items: center;
  border: 1px solid rgba(79, 131, 255, 0.3);
  border-radius: 11px;
  background: rgba(28, 98, 235, 0.12);
  color: var(--demo-blue-bright);
}

.feed-item-family__header svg {
  width: 18px;
  height: 18px;
}

.feed-item-family__header h3,
.feed-item-family__header p {
  margin: 0;
}

.feed-item-family__header h3 {
  font-size: clamp(1.55rem, 2.6vw, 2.45rem);
  line-height: 1.05;
  letter-spacing: -0.04em;
}

.feed-item-family__header p {
  margin-top: 8px;
  color: var(--demo-soft);
  font-size: 0.9rem;
  line-height: 1.55;
}

.feed-item-family__examples {
  display: grid;
  grid-template-columns: repeat(
    auto-fit,
    minmax(min(100%, 380px), 440px)
  );
  align-items: start;
  justify-content: start;
  gap: clamp(22px, 3vw, 36px);
}

.feed-item-example {
  min-width: 0;
}

.feed-item-example__context {
  min-height: 126px;
  padding: 0 2px 14px;
}

.feed-item-example__context > strong {
  display: block;
  min-height: 18px;
  color: #dce6ff;
  font-size: 0.74rem;
  letter-spacing: 0.01em;
}

.feed-item-example__context dl {
  display: grid;
  gap: 7px;
  margin: 12px 0 0;
}

.feed-item-example__context dl > div {
  display: grid;
  grid-template-columns: 76px minmax(0, 1fr);
  gap: 10px;
  align-items: baseline;
}

.feed-item-example__context dt,
.feed-item-example__context dd {
  margin: 0;
}

.feed-item-example__context dt {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: #7584a5;
  font-family: var(--ds-font-family-accent), monospace;
  font-size: 0.55rem;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.feed-item-example__context dt svg {
  width: 10px;
  height: 10px;
}

.feed-item-example__context dd {
  color: var(--demo-soft);
  font-size: 0.7rem;
  line-height: 1.4;
}

.feed-items-shell .feed-card,
.feed-items-shell .feed-data-visual {
  animation: none;
  will-change: auto;
}

.feed-item-rules {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  border-top: 1px solid var(--demo-line);
  border-bottom: 1px solid var(--demo-line);
}

.feed-item-rules > section {
  display: grid;
  min-width: 0;
  grid-template-columns: 38px minmax(0, 1fr);
  gap: 16px;
  padding: 28px 24px;
}

.feed-item-rules > section:nth-child(even) {
  border-left: 1px solid var(--demo-line);
}

.feed-item-rules > section:nth-child(n + 3) {
  border-top: 1px solid var(--demo-line);
}

.feed-item-rules > section > span {
  color: var(--demo-blue-bright);
  font-family: var(--ds-font-family-accent), monospace;
  font-size: 0.7rem;
}

.feed-item-rules h4,
.feed-item-rules p {
  margin: 0;
}

.feed-item-rules h4 {
  font-size: 1rem;
}

.feed-item-rules p {
  margin-top: 7px;
  color: var(--demo-soft);
  font-size: 0.82rem;
  line-height: 1.52;
}

@keyframes card-enter {
  from {
    opacity: 0;
    transform: translateY(-16px) scale(0.985);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes signal-pulse {
  0% {
    opacity: 0.2;
    transform: scale(0.78);
  }
  48% {
    opacity: 1;
  }
  100% {
    opacity: 0.15;
    transform: scale(1.08);
  }
}

@keyframes skeleton-shimmer {
  to {
    background-position: -220% 0;
  }
}

@keyframes orbit {
  to {
    transform: rotate(360deg);
  }
}

@media (min-width: 821px) {
  .feed-stage {
    min-height: calc(100dvh - 94px);
  }

  .game-phone {
    height: auto;
    min-height: calc(100dvh - 118px);
    overflow: clip;
  }

  .game-phone__header {
    position: sticky;
    top: 64px;
  }

  .game-feed {
    overflow-x: clip;
    overflow-y: visible;
    overscroll-behavior: auto;
    touch-action: auto;
  }
}

@media (min-width: 821px) and (max-height: 860px) {
  .presenter-rail {
    position: static;
    top: auto;
  }
}

@media (max-width: 1180px) {
  .demo-layout {
    grid-template-columns: minmax(250px, 310px) minmax(400px, 480px);
  }

  .presenter-rail--right {
    position: static;
    top: auto;
    grid-column: 2;
  }
}

@media (max-width: 820px) {
  .topbar {
    padding: 0 16px;
  }

  .topbar [data-slot="badge"] {
    display: none;
  }

  .site-nav {
    position: static;
    margin-left: auto;
    transform: none;
  }

  .demo-layout {
    grid-template-columns: minmax(0, 520px);
    gap: 24px;
    padding: 24px 14px 60px;
  }

  .feed-stage {
    grid-row: 1;
    grid-column: 1;
  }

  .presenter-rail--right {
    position: static;
    top: auto;
    grid-row: 2;
    grid-column: 1;
  }

  .presenter-rail--left {
    display: none;
  }

  .game-phone__mobile-controls {
    display: block;
    border-top: 1px solid rgba(134, 155, 205, 0.14);
    background: rgba(5, 9, 18, 0.84);
    padding: 10px 12px 12px;
  }

  .game-selector h1 {
    max-width: none;
    font-size: 2.2rem;
  }

  .feed-items-hero {
    grid-template-columns: 1fr;
  }

  .feed-items-hero__facts {
    max-width: 560px;
  }

}

@media (max-width: 600px) {
  .topbar {
    min-height: 58px;
  }

  .brand__product,
  .brand__divider {
    display: none;
  }

  .brand__logo {
    width: 108px;
    height: auto;
  }

  .site-nav a {
    padding: 6px 9px;
    font-size: 0.67rem;
  }

  .topbar [data-slot="badge"] {
    padding-right: 7px;
    padding-left: 7px;
    font-size: 0.58rem;
  }

  .demo-layout {
    min-height: calc(100dvh - 58px);
    padding: 18px 0 50px;
  }

  .presenter-rail {
    padding: 0 14px;
  }

  .game-selector h1 {
    font-size: 2rem;
  }

  .feed-stage__label {
    margin: 0 16px 8px;
  }

  .feed-stage__label span:last-child {
    display: none;
  }

  .game-phone {
    height: 720px;
    border-right: 0;
    border-left: 0;
    border-radius: 0;
    box-shadow: none;
  }

  .game-feed {
    padding: 12px;
  }

  .scoreboard {
    gap: 8px;
    padding-right: 14px;
    padding-left: 14px;
  }

  .team-score {
    gap: 7px;
  }

  .team-score__mark {
    width: 33px;
    height: 33px;
    border-radius: 8px;
  }

  .team-score__identity strong {
    font-size: 1.45rem;
  }

  .game-phone__competition,
  .game-phone__beat {
    padding-right: 14px;
    padding-left: 14px;
  }

  .feed-card__media {
    height: 200px;
  }

  .feed-card--moment .feed-card__media,
  .feed-card--recap .feed-card__media,
  .feed-card--highlight .feed-card__media {
    height: 225px;
  }

  .court-moment__sequence {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .court-moment__sequence li {
    font-size: 0.58rem;
  }

  .court-moment__sequence li:nth-child(3n)::after {
    display: block;
  }

  .court-moment__sequence li:nth-child(2n)::after,
  .court-moment__sequence li:last-child::after {
    display: none;
  }

  .feed-items-hero {
    padding: 52px 18px 70px;
  }

  .feed-items-hero h1 {
    font-size: clamp(3rem, 16vw, 4.5rem);
  }

  .feed-items-hero__facts > div {
    padding: 18px 8px;
  }

  .feed-items-section {
    padding: 64px 14px;
  }

  .feed-items-section__header {
    grid-template-columns: 1fr;
    gap: 14px;
  }

  .feed-item-family__header {
    grid-template-columns: 36px minmax(0, 1fr);
    gap: 12px;
  }

  .feed-item-family__header > span {
    width: 36px;
    height: 36px;
    border-radius: 9px;
  }

  .feed-item-example__context {
    min-height: 0;
  }

  .feed-item-rules {
    grid-template-columns: 1fr;
  }

  .feed-item-rules > section {
    padding: 24px 8px;
  }

  .feed-item-rules > section:nth-child(even) {
    border-left: 0;
  }

  .feed-item-rules > section + section {
    border-top: 1px solid var(--demo-line);
  }
}

@media (prefers-reduced-motion: reduce) {
  html {
    scroll-behavior: auto;
  }

  *,
  *::before,
  *::after {
    scroll-behavior: auto !important;
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}

@keyframes storyteller-spin {
  to {
    transform: rotate(1turn);
  }
}
`, "",{"version":3,"sources":["webpack://./src/app.css"],"names":[],"mappings":"AAQA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,2BAA2B;EAC3B,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,sCAAsC;EACtC,oBAAoB;EACpB,qBAAqB;EACrB,gCAAgC;EAChC,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT;;mBAEiB;EACjB,wBAAwB;EACxB,8DAA8D;EAC9D,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,gEAAgE;AAClE;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,yBAAyB;EACzB,oBAAoB;EACpB,mCAAmC;EACnC,YAAY;EACZ,yBAAyB;EACzB,oDAAoD;EACpD,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;;EAGE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,SAAS;EACT,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,MAAM;EACN,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,yCAAyC;EACzC,gCAAgC;EAChC,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,oDAAoD;EACpD,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,2CAA2C;EAC3C,oBAAoB;EACpB,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,yDAAyD;AAC3D;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,+BAA+B;EAC/B,qFAAqF;EACrF,kBAAkB;EAClB,uBAAuB;EACvB,2BAA2B;EAC3B,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,8BAA8B;EAC9B,oDAAoD;EACpD,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;EAGE,SAAS;EACT,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,QAAQ;EACR,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;EACnB,iCAAiC;EACjC,wBAAwB;EACxB,4BAA4B;EAC5B,gBAAgB;EAChB;;;wBAGsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,8CAA8C;AAChD;;AAEA;EACE,8BAA8B;EAC9B,oDAAoD;EACpD,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,kCAAkC;EAClC,mBAAmB;EACnB,iCAAiC;EACjC,2CAA2C;AAC7C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,oDAAoD;EACpD,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,oDAAoD;EACpD,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB;;;;GAIC;AACH;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,mCAAmC;EACnC,kBAAkB;EAClB,4BAA4B;EAC5B,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,QAAQ;EACR,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,oDAAoD;EACpD,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,oDAAoD;EACpD,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,2CAA2C;EAC3C,mBAAmB;EACnB,mBAAmB;EACnB;;wCAEsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,kDAAkD;EAClD,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;EACpB,cAAc;EACd,oDAAoD;EACpD,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;EACnB,oDAAoD;EACpD,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oDAAoD;EACpD,kBAAkB;EAClB,cAAc;EACd,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,oDAAoD;EACpD,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,8CAA8C;EAC9C,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,mCAAmC;EACnC,8CAA8C;EAC9C,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,4BAA4B;EAC5B,4CAA4C;EAC5C,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,2CAA2C;EAC3C,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,UAAU;EACV,8BAA8B;EAC9B,oDAAoD;EACpD,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,sBAAsB;EACtB,UAAU;EACV,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,oDAAoD;EACpD,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kDAAkD;EAClD,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kCAAkC;EAClC,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,iDAAiD;EACjD,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,2CAA2C;EAC3C,oBAAoB;EACpB,mCAAmC;EACnC,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,uCAAuC;EACvC,mCAAmC;AACrC;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,oDAAoD;EACpD,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB;EACrB,aAAa;EACb,sDAAsD;EACtD,qBAAqB;EACrB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,qBAAqB;EACrB,qBAAqB;EACrB,SAAS;EACT,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kCAAkC;EAClC,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mCAAmC;EACnC,4CAA4C;EAC5C,WAAW;EACX,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,2CAA2C;EAC3C,mBAAmB;EACnB,4BAA4B;EAC5B,2CAA2C;EAC3C,+DAA+D;EAC/D,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,sBAAsB;EACtB,mDAAmD;EACnD,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;EAGE,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,0CAA0C;EAC1C,mBAAmB;EACnB,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,oDAAoD;EACpD,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,2CAA2C;EAC3C,kBAAkB;EAClB,mCAAmC;EACnC,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,eAAe;AACjB;;AAEA;;EAEE,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,uBAAuB;EACvB,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR;;oEAEkE;AACpE;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,gCAAgC;EAChC,2CAA2C;EAC3C,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gCAAgC;EAChC,oDAAoD;EACpD,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,0DAA0D;AAC5D;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,2CAA2C;EAC3C,oBAAoB;EACpB,gCAAgC;EAChC,gCAAgC;EAChC,oDAAoD;EACpD,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;;;EAGE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,SAAS;EACT,iDAAiD;EACjD;;WAES;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,oDAAoD;EACpD,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,oDAAoD;EACpD,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,QAAQ;EACR,+CAA+C;EAC/C,kDAAkD;EAClD,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,oDAAoD;EACpD,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,2CAA2C;EAC3C,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,SAAS;EACT,QAAQ;EACR,2CAA2C;EAC3C,kBAAkB;EAClB,gCAAgC;EAChC,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,gFAAgF;AAClF;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,0EAA0E;EAC1E,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,wBAAwB;EACxB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,gCAAgC;EAChC,2CAA2C;EAC3C,0BAA0B;EAC1B,eAAe;EACf,gCAAgC;EAChC,6DAA6D;AAC/D;;AAEA;EACE,mCAAmC;EACnC,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,oDAAoD;EACpD,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yDAAyD;EACzD,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,SAAS;EACT,YAAY;EACZ,uCAAuC;EACvC,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,2CAA2C;EAC3C,mBAAmB;EACnB;;WAES;EACT,mEAAmE;AACrE;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;EAKE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;;;;;EAKE,yDAAyD;EACzD,oDAAoD;EACpD,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;;;;EAKE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kCAAkC;EAClC,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,oDAAoD;EACpD,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,SAAS;EACT,WAAW;EACX,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gEAAgE;EAChE,gEAAgE;AAClE;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,0DAA0D;EAC1D,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,eAAe;EACf,cAAc;EACd,oDAAoD;EACpD,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gEAAgE;AAClE;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,0DAA0D;EAC1D,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,eAAe;EACf,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;EACd,oDAAoD;EACpD,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;AACpB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,0EAA0E;EAC1E,kBAAkB;EAClB,oEAAoE;EACpE,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,gDAAgD;EAChD,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;;EAEE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;;;EAIE,SAAS;AACX;;AAEA;;EAEE,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,oDAAoD;EACpD,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,iDAAiD;EACjD,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,iBAAiB;EACjB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,yDAAyD;EACzD,oDAAoD;EACpD,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,oDAAoD;EACpD,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,8EAA8E;AAChF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;EAEE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,0CAA0C;EAC1C,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,gEAAgE;EAChE,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,oDAAoD;EACpD,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,oDAAoD;EACpD,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,2EAA2E;EAC3E,sBAAsB;EACtB,qEAAqE;AACvE;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,gBAAgB;EAChB,+CAA+C;EAC/C,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,oDAAoD;EACpD,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,0CAA0C;EAC1C,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,uBAAuB;EACvB,UAAU;EACV,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yDAAyD;AAC3D;;AAEA;EACE,uBAAuB;EACvB,oDAAoD;EACpD,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,sEAAsE;EACtE;;oBAEkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;EACV,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC;;WAES;AACX;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,+BAA+B;EAC/B,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB;;;;;GAKC;EACD,0BAA0B;EAC1B,gDAAgD;AAClD;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,sCAAsC;EACtC,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,oDAAoD;EACpD,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,2CAA2C;EAC3C,mBAAmB;EACnB,iCAAiC;EACjC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,2DAA2D;EAC3D,gBAAgB;EAChB,4BAA4B;EAC5B,cAAc;EACd,+EAA+E;AACjF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,qCAAqC;EACrC,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,sCAAsC;EACtC,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,SAAS;EACT,oDAAoD;EACpD,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;EACxB,cAAc;EACd,uDAAuD;AACzD;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,4CAA4C;EAC5C,SAAS;EACT,qCAAqC;AACvC;;AAEA;EACE,gCAAgC;EAChC,oDAAoD;EACpD,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,uCAAuC;EACvC,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,yCAAyC;EACzC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,0CAA0C;EAC1C,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yCAAyC;EACzC,mBAAmB;EACnB,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,yCAAyC;EACzC,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb;;;GAGC;EACD,kBAAkB;EAClB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,SAAS;EACT,qBAAqB;AACvB;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,oDAAoD;EACpD,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,sCAAsC;EACtC,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,0CAA0C;EAC1C,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;EAC9B,oDAAoD;EACpD,iBAAiB;AACnB;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE;IACE,UAAU;IACV,yCAAyC;EAC3C;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,YAAY;IACZ,sBAAsB;EACxB;EACA;IACE,UAAU;EACZ;EACA;IACE,aAAa;IACb,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,+BAA+B;EACjC;;EAEA;IACE,YAAY;IACZ,gCAAgC;IAChC,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,SAAS;EACX;AACF;;AAEA;EACE;IACE,gEAAgE;EAClE;;EAEA;IACE,gBAAgB;IAChB,SAAS;IACT,cAAc;EAChB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,uCAAuC;IACvC,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,SAAS;IACT,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,+CAA+C;IAC/C,gCAAgC;IAChC,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;;AAEF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,+BAA+B;IAC/B,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,QAAQ;IACR,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;;;IAGE,aAAa;EACf;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,0CAA0C;IAC1C,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,sCAAsC;EACxC;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;;;IAGE,gCAAgC;IAChC,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;EACxC;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF","sourcesContent":["@import \"@fontsource/dm-sans/300.css\";\n@import \"@fontsource/dm-sans/400.css\";\n@import \"@fontsource/dm-sans/500.css\";\n@import \"@fontsource/dm-sans/600.css\";\n@import \"@fontsource/dm-sans/700.css\";\n@import \"@fontsource/space-mono/400.css\";\n@import \"@fontsource/space-mono/700.css\";\n\n:root {\n  color-scheme: dark;\n  --demo-blue: #4f83ff;\n  --demo-blue-bright: #77a3ff;\n  --demo-ink: #020617;\n  --demo-panel: #08101f;\n  --demo-card: #0d1525;\n  --demo-line: rgba(134, 155, 205, 0.22);\n  --demo-soft: #98a7c6;\n  --demo-white: #f7f9ff;\n  --ds-font-family-base: \"DM Sans\";\n  --ds-font-family-accent: \"Space Mono\";\n}\n\nhtml {\n  min-width: 320px;\n  min-height: 100%;\n  scroll-behavior: smooth;\n}\n\nbody {\n  min-width: 320px;\n  min-height: 100%;\n  margin: 0;\n  background:\n    radial-gradient(circle at 50% -10%, rgba(28, 98, 235, 0.16), transparent 31rem),\n    var(--demo-ink);\n  color: var(--demo-white);\n  font-family: var(--ds-font-family-base), system-ui, sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\na {\n  color: inherit;\n  text-decoration: none;\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n[data-slot=\"button\"] {\n  display: inline-flex;\n  min-width: 40px;\n  min-height: 40px;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  border: 0;\n  border-radius: 8px;\n  background: #1c62eb;\n  color: white;\n  padding: 9px 15px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  transition: background-color 160ms ease, border-color 160ms ease;\n}\n\n[data-slot=\"button\"]:hover {\n  background: #3373ef;\n}\n\n[data-slot=\"button\"]:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n[data-slot=\"button\"]:focus-visible {\n  outline: 2px solid var(--demo-blue-bright);\n  outline-offset: 2px;\n}\n\n[data-slot=\"button\"] svg {\n  width: 16px;\n  height: 16px;\n  flex: 0 0 auto;\n}\n\n[data-slot=\"badge\"] {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n  border: 1px solid #1c62eb;\n  border-radius: 999px;\n  background: rgba(28, 98, 235, 0.34);\n  color: white;\n  padding: 4px 10px 4px 8px;\n  font-family: var(--ds-font-family-accent), monospace;\n  font-size: 0.68rem;\n  font-weight: 700;\n}\n\nbutton,\ninput,\nselect,\nsummary {\n  font: inherit;\n}\n\nbutton,\nselect,\nsummary {\n  touch-action: manipulation;\n}\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  margin: -1px;\n  padding: 0;\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n}\n\n.demo-shell {\n  min-height: 100dvh;\n}\n\n.topbar {\n  position: sticky;\n  z-index: 50;\n  top: 0;\n  display: flex;\n  min-height: 64px;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid var(--demo-line);\n  background: rgba(2, 6, 23, 0.92);\n  padding: 0 28px;\n  backdrop-filter: blur(18px);\n}\n\n.brand {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  color: var(--demo-white);\n}\n\n.brand:focus-visible {\n  border-radius: 8px;\n  outline: 2px solid var(--demo-blue-bright);\n  outline-offset: 5px;\n}\n\n.brand__logo {\n  display: block;\n  flex: 0 0 auto;\n}\n\n.brand__divider {\n  width: 1px;\n  height: 20px;\n  margin: 0 2px;\n  background: var(--demo-line);\n}\n\n.brand__product {\n  color: var(--demo-soft);\n  font-family: var(--ds-font-family-accent), monospace;\n  font-size: 0.67rem;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n}\n\n.topbar [data-slot=\"badge\"] svg {\n  width: 10px;\n  height: 10px;\n}\n\n.site-nav {\n  position: absolute;\n  left: 50%;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px;\n  border: 1px solid rgba(134, 155, 205, 0.16);\n  border-radius: 999px;\n  background: rgba(8, 16, 31, 0.78);\n  transform: translateX(-50%);\n}\n\n.site-nav a {\n  border-radius: 999px;\n  color: var(--demo-soft);\n  padding: 6px 12px;\n  font-size: 0.73rem;\n  font-weight: 600;\n  transition: background-color 160ms ease, color 160ms ease;\n}\n\n.site-nav a:hover {\n  color: white;\n}\n\n.site-nav a[aria-current=\"page\"] {\n  background: rgba(28, 98, 235, 0.28);\n  color: white;\n}\n\n.site-nav a:focus-visible {\n  outline: 2px solid var(--demo-blue-bright);\n  outline-offset: 2px;\n}\n\n.demo-layout {\n  display: grid;\n  width: min(100%, 1400px);\n  min-height: calc(100dvh - 64px);\n  grid-template-columns: minmax(260px, 320px) minmax(400px, 480px) minmax(250px, 300px);\n  align-items: start;\n  justify-content: center;\n  gap: clamp(24px, 3vw, 48px);\n  margin: 0 auto;\n  padding: 30px clamp(20px, 3vw, 48px) 80px;\n}\n\n.presenter-rail {\n  position: sticky;\n  top: 94px;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.section-kicker {\n  display: block;\n  margin-bottom: 8px;\n  color: var(--demo-blue-bright);\n  font-family: var(--ds-font-family-accent), monospace;\n  font-size: 0.67rem;\n  font-weight: 700;\n  letter-spacing: 0.13em;\n  text-transform: uppercase;\n}\n\n.game-selector {\n  padding: 4px 2px 0;\n}\n\n.game-selector h1,\n.control-card h2,\n.intelligence-card h2 {\n  margin: 0;\n  font-weight: 700;\n  letter-spacing: -0.045em;\n}\n\n.game-selector h1 {\n  max-width: 10ch;\n  font-size: clamp(2rem, 3vw, 3rem);\n  line-height: 0.98;\n}\n\n.game-selector > p,\n.intelligence-card > p {\n  margin: 14px 0 0;\n  color: var(--demo-soft);\n  font-size: 0.92rem;\n  line-height: 1.55;\n}\n\n.game-selector__options {\n  display: grid;\n  gap: 8px;\n  margin-top: 22px;\n}\n\n.game-selector__options button {\n  position: relative;\n  display: grid;\n  width: 100%;\n  gap: 2px;\n  overflow: hidden;\n  border: 1px solid var(--demo-line);\n  border-radius: 10px;\n  background: rgba(8, 16, 31, 0.68);\n  color: var(--demo-white);\n  padding: 14px 15px 14px 44px;\n  text-align: left;\n  transition:\n    border-color 180ms ease,\n    background-color 180ms ease,\n    transform 180ms ease;\n}\n\n.game-selector__options button::before {\n  position: absolute;\n  top: 16px;\n  left: 15px;\n  width: 12px;\n  height: 12px;\n  border: 1px solid rgba(152, 167, 198, 0.6);\n  border-radius: 50%;\n  content: \"\";\n  transition: 180ms ease;\n}\n\n.game-selector__options button:hover {\n  border-color: rgba(119, 163, 255, 0.5);\n  background: rgba(28, 98, 235, 0.08);\n  transform: translateY(-1px);\n}\n\n.game-selector__options button:focus-visible {\n  outline: 2px solid var(--demo-blue-bright);\n  outline-offset: 2px;\n}\n\n.game-selector__options button.is-selected {\n  border-color: rgba(79, 131, 255, 0.7);\n  background: rgba(28, 98, 235, 0.14);\n}\n\n.game-selector__options button.is-selected::before {\n  border: 3px solid #a9c4ff;\n  background: var(--demo-blue);\n  box-shadow: 0 0 0 4px rgba(79, 131, 255, 0.14);\n}\n\n.game-selector__options button > span {\n  color: var(--demo-blue-bright);\n  font-family: var(--ds-font-family-accent), monospace;\n  font-size: 0.65rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n}\n\n.game-selector__options button strong {\n  font-size: 0.9rem;\n  line-height: 1.35;\n}\n\n.game-selector__options button small {\n  color: var(--demo-soft);\n  font-size: 0.7rem;\n}\n\n.storypilot-game-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  margin-top: 14px;\n  color: #c9d8ff;\n  font-size: 0.76rem;\n  font-weight: 600;\n}\n\n.storypilot-game-link:hover {\n  color: white;\n}\n\n.storypilot-game-link:focus-visible {\n  border-radius: 5px;\n  outline: 2px solid var(--demo-blue-bright);\n  outline-offset: 4px;\n}\n\n.storypilot-game-link svg {\n  width: 14px;\n  height: 14px;\n}\n\n.control-card,\n.intelligence-card {\n  border: 1px solid var(--demo-line);\n  border-radius: 12px;\n  background: rgba(8, 16, 31, 0.74);\n  box-shadow: 0 18px 55px rgba(0, 0, 0, 0.18);\n}\n\n.control-card {\n  padding: 17px;\n}\n\n.control-card__heading {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.control-card h2 {\n  max-width: 13ch;\n  font-size: 1.15rem;\n  line-height: 1.1;\n}\n\n.status-dot {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  color: var(--demo-soft);\n  font-family: var(--ds-font-family-accent), monospace;\n  font-size: 0.58rem;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.status-dot::before {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #66728d;\n  content: \"\";\n}\n\n.status-dot--playing::before {\n  background: #36d27e;\n  box-shadow: 0 0 0 4px rgba(54, 210, 126, 0.12);\n}\n\n.status-dot--complete::before {\n  background: var(--demo-blue-bright);\n}\n\n.transport-controls {\n  display: grid;\n  grid-template-columns: 40px 1fr;\n  gap: 8px;\n  margin-top: 18px;\n}\n\n.transport-controls [data-slot=\"button\"] {\n  width: 100%;\n}\n\n.transport-controls [data-slot=\"button\"]:first-child {\n  border: 1px solid var(--demo-line);\n  background: transparent;\n}\n\n.transport-controls [data-slot=\"button\"]:first-child:hover {\n  background: rgba(134, 155, 205, 0.12);\n}\n\n.transport-controls__primary {\n  box-shadow: 0 8px 24px rgba(28, 98, 235, 0.24);\n}\n\n.replay-scrubber {\n  display: grid;\n  gap: 9px;\n  margin-top: 18px;\n}\n\n.replay-scrubber > span,\n.rate-control {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  color: var(--demo-soft);\n  font-family: var(--ds-font-family-accent), monospace;\n  font-size: 0.62rem;\n  letter-spacing: 0.04em;\n}\n\n.replay-scrubber output {\n  color: var(--demo-white);\n  font-variant-numeric: tabular-nums;\n}\n\n.replay-scrubber input {\n  width: 100%;\n  height: 16px;\n  margin: 0;\n  appearance: none;\n  background: transparent;\n  cursor: pointer;\n}\n\n.replay-scrubber input::-webkit-slider-runnable-track {\n  height: 4px;\n  border-radius: 4px;\n  background: linear-gradient(\n    to right,\n    var(--demo-blue) 0 var(--scrub-progress),\n    rgba(134, 155, 205, 0.22) var(--scrub-progress) 100%\n  );\n}\n\n.replay-scrubber input::-moz-range-track {\n  height: 4px;\n  border-radius: 4px;\n  background: rgba(134, 155, 205, 0.22);\n}\n\n.replay-scrubber input::-moz-range-progress {\n  height: 4px;\n  border-radius: 4px;\n  background: var(--demo-blue);\n}\n\n.replay-scrubber input::-webkit-slider-thumb {\n  width: 14px;\n  height: 14px;\n  margin-top: -5px;\n  appearance: none;\n  border: 3px solid var(--demo-white);\n  border-radius: 50%;\n  background: var(--demo-blue);\n  box-shadow: 0 0 0 3px rgba(79, 131, 255, 0.15);\n}\n\n.replay-scrubber input::-moz-range-thumb {\n  width: 10px;\n  height: 10px;\n  border: 3px solid var(--demo-white);\n  border-radius: 50%;\n  background: var(--demo-blue);\n}\n\n.replay-scrubber input:focus-visible {\n  outline: 2px solid var(--demo-blue-bright);\n  outline-offset: 4px;\n}\n\n.rate-control {\n  margin-top: 15px;\n}\n\n.rate-control > div {\n  display: inline-flex;\n  gap: 2px;\n  padding: 2px;\n  border: 1px solid var(--demo-line);\n  border-radius: 7px;\n}\n\n.rate-control button {\n  min-width: 34px;\n  border: 0;\n  border-radius: 5px;\n  background: transparent;\n  color: var(--demo-soft);\n  padding: 4px 6px;\n  font-family: var(--ds-font-family-accent), monospace;\n  font-size: 0.61rem;\n}\n\n.rate-control button[aria-pressed=\"true\"] {\n  background: var(--demo-blue);\n  color: white;\n}\n\n.rate-control button:focus-visible {\n  outline: 2px solid var(--demo-blue-bright);\n  outline-offset: 1px;\n}\n\n.feed-stage {\n  min-width: 0;\n}\n\n.feed-stage__label {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin: 0 4px 10px;\n  color: var(--demo-soft);\n  font-family: var(--ds-font-family-accent), monospace;\n  font-size: 0.59rem;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n}\n\n.feed-stage__label span:first-child {\n  color: var(--demo-blue-bright);\n  font-weight: 700;\n}\n\n.game-phone {\n  position: relative;\n  display: flex;\n  width: 100%;\n  height: 760px;\n  overflow: hidden;\n  flex-direction: column;\n  border: 1px solid rgba(134, 155, 205, 0.34);\n  border-radius: 26px;\n  background: #070b14;\n  box-shadow:\n    0 40px 100px rgba(0, 0, 0, 0.45),\n    0 0 0 6px rgba(255, 255, 255, 0.018);\n}\n\n.game-phone__header {\n  position: relative;\n  z-index: 20;\n  flex: 0 0 auto;\n  border-bottom: 1px solid rgba(134, 155, 205, 0.16);\n  background: rgba(7, 11, 20, 0.94);\n  backdrop-filter: blur(16px);\n}\n\n.game-phone__competition {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 17px 20px 0;\n  color: #b8c4dc;\n  font-family: var(--ds-font-family-accent), monospace;\n  font-size: 0.6rem;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.game-phone__live {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  color: #68e79f;\n}\n\n.game-phone__live svg {\n  width: 11px;\n  height: 11px;\n}\n\n.scoreboard {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  align-items: center;\n  gap: 14px;\n  padding: 15px 20px 14px;\n}\n\n.team-score {\n  display: flex;\n  min-width: 0;\n  align-items: center;\n  gap: 10px;\n}\n\n.team-score--right {\n  flex-direction: row-reverse;\n  text-align: right;\n}\n\n.team-score__mark {\n  display: grid;\n  width: 38px;\n  height: 38px;\n  flex: 0 0 auto;\n  place-items: center;\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  border-radius: 10px;\n  font-family: var(--ds-font-family-accent), monospace;\n  font-size: 0.58rem;\n  font-weight: 700;\n  letter-spacing: -0.03em;\n}\n\n.team-score__identity {\n  display: grid;\n  min-width: 0;\n  gap: 1px;\n}\n\n.team-score__identity span {\n  overflow: hidden;\n  color: var(--demo-soft);\n  font-size: 0.68rem;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.team-score__identity strong {\n  font-family: var(--ds-font-family-accent), monospace;\n  font-size: 1.65rem;\n  line-height: 1;\n  font-variant-numeric: tabular-nums;\n  letter-spacing: -0.08em;\n}\n\n.scoreboard__clock {\n  display: grid;\n  min-width: 62px;\n  gap: 3px;\n  color: var(--demo-soft);\n  text-align: center;\n}\n\n.scoreboard__clock span {\n  font-size: 0.61rem;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.scoreboard__clock strong {\n  color: var(--demo-white);\n  font-family: var(--ds-font-family-accent), monospace;\n  font-size: 0.74rem;\n  font-variant-numeric: tabular-nums;\n}\n\n.game-phone__beat {\n  display: flex;\n  min-height: 34px;\n  align-items: center;\n  border-top: 1px solid rgba(134, 155, 205, 0.1);\n  padding: 8px 20px;\n  color: #c9d3e8;\n  font-size: 0.71rem;\n  line-height: 1.35;\n}\n\n.game-phone__beat::before {\n  width: 5px;\n  height: 5px;\n  flex: 0 0 auto;\n  margin-right: 8px;\n  border-radius: 50%;\n  background: var(--demo-blue-bright);\n  box-shadow: 0 0 0 4px rgba(79, 131, 255, 0.12);\n  content: \"\";\n}\n\n.game-phone__progress {\n  height: 2px;\n  overflow: hidden;\n  background: rgba(134, 155, 205, 0.1);\n}\n\n.game-phone__progress span {\n  display: block;\n  height: 100%;\n  background: var(--demo-blue);\n  box-shadow: 0 0 10px rgba(79, 131, 255, 0.7);\n  transition: width 90ms linear;\n}\n\n.game-phone__mobile-controls {\n  display: none;\n}\n\n.mobile-game-controls {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  gap: 8px;\n}\n\n.mobile-game-controls__game {\n  position: relative;\n  display: grid;\n  min-width: 0;\n  min-height: 48px;\n  border: 1px solid rgba(134, 155, 205, 0.28);\n  border-radius: 10px;\n  background: rgba(2, 6, 23, 0.52);\n}\n\n.mobile-game-controls__game > span {\n  position: absolute;\n  z-index: 1;\n  top: 6px;\n  left: 12px;\n  color: var(--demo-blue-bright);\n  font-family: var(--ds-font-family-accent), monospace;\n  font-size: 0.5rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  pointer-events: none;\n}\n\n.mobile-game-controls__game select {\n  width: 100%;\n  min-width: 0;\n  min-height: 46px;\n  appearance: none;\n  overflow: hidden;\n  border: 0;\n  border-radius: inherit;\n  outline: 0;\n  background: transparent;\n  color: var(--demo-white);\n  padding: 17px 36px 3px 11px;\n  font-size: 0.77rem;\n  font-weight: 700;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  cursor: pointer;\n}\n\n.mobile-game-controls__game:focus-within {\n  outline: 2px solid var(--demo-blue-bright);\n  outline-offset: 2px;\n}\n\n.mobile-game-controls__game > svg {\n  position: absolute;\n  top: 50%;\n  right: 11px;\n  width: 16px;\n  height: 16px;\n  color: var(--demo-soft);\n  pointer-events: none;\n  transform: translateY(-50%);\n}\n\n.mobile-game-controls__primary[data-slot=\"button\"] {\n  min-width: 96px;\n  min-height: 48px;\n}\n\n.mobile-game-controls__details {\n  min-width: 0;\n  grid-column: 1 / -1;\n  border: 1px solid rgba(134, 155, 205, 0.22);\n  border-radius: 10px;\n  background: rgba(2, 6, 23, 0.42);\n}\n\n.mobile-game-controls__details summary {\n  display: flex;\n  min-height: 44px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  border-radius: inherit;\n  color: #c9d3e8;\n  padding: 0 12px;\n  font-family: var(--ds-font-family-accent), monospace;\n  font-size: 0.62rem;\n  cursor: pointer;\n  list-style: none;\n}\n\n.mobile-game-controls__details summary::-webkit-details-marker {\n  display: none;\n}\n\n.mobile-game-controls__details summary:focus-visible {\n  outline: 2px solid var(--demo-blue-bright);\n  outline-offset: 2px;\n}\n\n.mobile-game-controls__details summary > span {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n}\n\n.mobile-game-controls__details summary svg {\n  width: 15px;\n  height: 15px;\n}\n\n.mobile-game-controls__details summary > span:last-child svg {\n  transition: transform 160ms ease;\n}\n\n.mobile-game-controls__details[open] summary {\n  border-bottom: 1px solid rgba(134, 155, 205, 0.18);\n  border-radius: 10px 10px 0 0;\n}\n\n.mobile-game-controls__details[open] summary > span:last-child svg {\n  transform: rotate(180deg);\n}\n\n.mobile-game-controls__panel {\n  padding: 13px 12px 12px;\n}\n\n.mobile-game-controls__status {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.mobile-game-controls__status .section-kicker {\n  margin: 0;\n}\n\n.mobile-game-controls__panel .replay-scrubber {\n  margin-top: 13px;\n}\n\n.mobile-game-controls__panel .replay-scrubber input {\n  height: 44px;\n}\n\n.mobile-game-controls__panel .rate-control button {\n  min-width: 44px;\n  min-height: 44px;\n}\n\n.mobile-game-controls__actions {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n  margin-top: 13px;\n}\n\n.mobile-game-controls__actions [data-slot=\"button\"] {\n  min-height: 44px;\n  border: 1px solid var(--demo-line);\n  background: rgba(134, 155, 205, 0.08);\n}\n\n.mobile-game-controls__actions a {\n  display: inline-flex;\n  min-height: 44px;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  border: 1px solid var(--demo-line);\n  border-radius: 8px;\n  color: #c9d8ff;\n  padding: 8px 10px;\n  font-size: 0.7rem;\n  font-weight: 700;\n  text-align: center;\n}\n\n.mobile-game-controls__actions a:focus-visible {\n  outline: 2px solid var(--demo-blue-bright);\n  outline-offset: 2px;\n}\n\n.mobile-game-controls__actions a svg {\n  width: 14px;\n  height: 14px;\n  flex: 0 0 auto;\n}\n\n.game-phone__updates {\n  z-index: 18;\n  flex: 0 0 auto;\n  border-bottom: 1px solid rgba(119, 163, 255, 0.2);\n  background: rgba(8, 16, 31, 0.96);\n  padding: 8px 12px;\n}\n\n.game-phone__updates button {\n  display: flex;\n  width: 100%;\n  min-height: 44px;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  border: 1px solid rgba(119, 163, 255, 0.38);\n  border-radius: 999px;\n  background: rgba(28, 98, 235, 0.16);\n  color: #e9efff;\n  padding: 8px 14px;\n  font-size: 0.72rem;\n  cursor: pointer;\n}\n\n.game-phone__updates button:hover {\n  border-color: rgba(119, 163, 255, 0.68);\n  background: rgba(28, 98, 235, 0.28);\n}\n\n.game-phone__updates button:focus-visible {\n  outline: 2px solid var(--demo-blue-bright);\n  outline-offset: 2px;\n}\n\n.game-phone__updates button svg {\n  width: 15px;\n  height: 15px;\n}\n\n.game-phone__updates button strong {\n  color: var(--demo-blue-bright);\n  font-family: var(--ds-font-family-accent), monospace;\n  font-size: 0.6rem;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.game-feed {\n  display: flex;\n  min-height: 0;\n  flex: 1 1 auto;\n  flex-direction: column;\n  gap: 12px;\n  overflow-x: hidden;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  overflow-anchor: none;\n  padding: 14px;\n  scrollbar-color: rgba(134, 155, 205, 0.35) transparent;\n  scrollbar-width: thin;\n  touch-action: pan-y;\n  -webkit-overflow-scrolling: touch;\n}\n\n.game-feed__waiting {\n  display: grid;\n  min-height: 420px;\n  place-content: center;\n  justify-items: center;\n  gap: 18px;\n  color: var(--demo-soft);\n  font-size: 0.8rem;\n}\n\n.game-feed__waiting-orbit {\n  position: relative;\n  width: 42px;\n  height: 42px;\n  border: 1px solid rgba(79, 131, 255, 0.5);\n  border-radius: 50%;\n}\n\n.game-feed__waiting-orbit::before {\n  position: absolute;\n  inset: 9px;\n  border: 1px solid var(--demo-blue);\n  border-radius: 50%;\n  content: \"\";\n}\n\n.game-feed__waiting-orbit::after {\n  position: absolute;\n  top: -3px;\n  left: 18px;\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--demo-blue-bright);\n  box-shadow: 0 0 14px rgba(79, 131, 255, 0.9);\n  content: \"\";\n  animation: orbit 2.2s linear infinite;\n  transform-origin: 3px 24px;\n}\n\n.feed-card {\n  --asset-accent: var(--demo-blue);\n  position: relative;\n  min-width: 0;\n  max-width: 100%;\n  overflow: hidden;\n  flex: 0 0 auto;\n  border: 1px solid rgba(134, 155, 205, 0.18);\n  border-radius: 18px;\n  background: var(--demo-card);\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.19);\n  animation: card-enter 460ms cubic-bezier(0.22, 1, 0.36, 1) both;\n  will-change: transform, opacity;\n}\n\n.feed-card::after {\n  position: absolute;\n  inset: 0;\n  border-radius: inherit;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);\n  content: \"\";\n  pointer-events: none;\n}\n\n.feed-card__media {\n  position: relative;\n  height: 210px;\n  overflow: hidden;\n  background: #10182a;\n}\n\n.feed-card__media--landscape,\n.feed-card__media--square,\n.feed-card__media--portrait {\n  height: auto;\n}\n\n.feed-card__media--landscape {\n  aspect-ratio: 16 / 9;\n}\n\n.feed-card__media--square {\n  aspect-ratio: 1;\n}\n\n.feed-card__media--portrait {\n  aspect-ratio: 4 / 5;\n}\n\n.feed-card__media img,\n.feed-card__media video {\n  display: block;\n  width: 100%;\n  height: 100%;\n  max-width: 100%;\n  object-fit: cover;\n}\n\n.feed-card__media img {\n  transition: transform 900ms cubic-bezier(0.22, 1, 0.36, 1);\n}\n\n.feed-card:hover .feed-card__media img {\n  transform: scale(1.025);\n}\n\n.storyteller-clip,\n.storyteller-story {\n  position: relative;\n  width: 100%;\n  max-width: 100%;\n  aspect-ratio: 9 / 16;\n  overflow: hidden;\n  background: #060a13;\n  isolation: isolate;\n}\n\n.storyteller-clip__poster,\n.storyteller-story__launcher > img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.storyteller-clip__poster {\n  position: absolute;\n  z-index: 0;\n  inset: 0;\n  transition: opacity 180ms ease;\n}\n\n.storyteller-clip[data-load-state=\"ready\"] .storyteller-clip__poster {\n  opacity: 0;\n}\n\n.storyteller-clip__mount {\n  position: absolute;\n  z-index: 1;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n\n.storyteller-clip__mount > * {\n  width: 100% !important;\n  height: 100% !important;\n  max-width: 100% !important;\n}\n\n.storyteller-clip__status {\n  position: absolute;\n  z-index: 3;\n  right: 14px;\n  bottom: 14px;\n  left: 14px;\n  display: flex;\n  min-height: 48px;\n  align-items: center;\n  justify-content: center;\n  gap: 9px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 12px;\n  background: rgba(3, 7, 18, 0.84);\n  color: white;\n  padding: 10px 12px;\n  font-family: var(--ds-font-family-accent), monospace;\n  font-size: 0.62rem;\n  letter-spacing: 0.035em;\n  text-transform: uppercase;\n  backdrop-filter: blur(12px);\n}\n\n.storyteller-clip__status--error {\n  justify-content: space-between;\n}\n\n.storyteller-clip__status button {\n  display: inline-flex;\n  min-height: 44px;\n  align-items: center;\n  gap: 7px;\n  border: 1px solid rgba(255, 255, 255, 0.28);\n  border-radius: 9px;\n  background: rgba(28, 98, 235, 0.78);\n  color: white;\n  padding: 8px 11px;\n  font: inherit;\n  cursor: pointer;\n}\n\n.storyteller-clip__status button:focus-visible,\n.storyteller-story__launcher:focus-visible {\n  outline: 2px solid white;\n  outline-offset: -4px;\n}\n\n.storyteller-clip__status button svg {\n  width: 15px;\n  height: 15px;\n}\n\n.storyteller-clip__spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid rgba(255, 255, 255, 0.26);\n  border-top-color: white;\n  border-radius: 50%;\n  animation: storyteller-spin 800ms linear infinite;\n}\n\n.storyteller-story__launcher {\n  position: absolute;\n  inset: 0;\n  display: block;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  border: 0;\n  background: #060a13;\n  color: white;\n  padding: 0;\n  text-align: left;\n  cursor: pointer;\n}\n\n.storyteller-story__launcher > img {\n  transition: transform 700ms cubic-bezier(0.22, 1, 0.36, 1);\n}\n\n.storyteller-story__launcher:hover > img {\n  transform: scale(1.025);\n}\n\n.storyteller-story__shade {\n  position: absolute;\n  inset: 0;\n  background:\n    linear-gradient(to bottom, rgba(4, 8, 18, 0.08) 40%, rgba(4, 8, 18, 0.88)),\n    linear-gradient(to right, rgba(4, 8, 18, 0.26), transparent 62%);\n}\n\n.storyteller-story__play {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  display: grid;\n  width: 62px;\n  height: 62px;\n  place-items: center;\n  border: 1px solid rgba(255, 255, 255, 0.72);\n  border-radius: 50%;\n  background: rgba(3, 7, 18, 0.46);\n  box-shadow: 0 16px 34px rgba(0, 0, 0, 0.34);\n  transform: translate(-50%, -50%);\n  backdrop-filter: blur(10px);\n}\n\n.storyteller-story__play svg {\n  width: 30px;\n  height: 30px;\n}\n\n.storyteller-story__copy {\n  position: absolute;\n  right: 18px;\n  bottom: 18px;\n  left: 18px;\n  display: grid;\n  gap: 5px;\n}\n\n.storyteller-story__copy small {\n  color: rgba(255, 255, 255, 0.72);\n  font-family: var(--ds-font-family-accent), monospace;\n  font-size: 0.58rem;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n}\n\n.storyteller-story__copy strong {\n  max-width: 16ch;\n  font-size: 1.26rem;\n  line-height: 1.08;\n  letter-spacing: -0.035em;\n}\n\n.feed-card--insight .feed-card__media {\n  height: 168px;\n}\n\n.feed-card--moment .feed-card__media {\n  height: 245px;\n}\n\n.feed-card--moment .feed-card__media img {\n  object-position: center 26%;\n}\n\n.feed-card--recap .feed-card__media,\n.feed-card--highlight .feed-card__media {\n  height: 230px;\n}\n\n.feed-card__gallery {\n  position: relative;\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 2px;\n  overflow: hidden;\n  background: rgba(134, 155, 205, 0.18);\n}\n\n.feed-card__gallery figure {\n  position: relative;\n  aspect-ratio: 1;\n  margin: 0;\n  overflow: hidden;\n  background: #10182a;\n}\n\n.feed-card__gallery:has(figure:nth-child(3):last-child) figure:first-child {\n  grid-column: 1 / -1;\n  aspect-ratio: 2 / 1;\n}\n\n.feed-card__gallery img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 900ms cubic-bezier(0.22, 1, 0.36, 1);\n}\n\n.feed-card--gallery:hover .feed-card__gallery img {\n  transform: scale(1.025);\n}\n\n.feed-card__gallery-credit {\n  position: absolute;\n  right: 8px;\n  bottom: 8px;\n  padding: 4px 6px;\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  border-radius: 999px;\n  background: rgba(3, 7, 18, 0.76);\n  color: rgba(255, 255, 255, 0.78);\n  font-family: var(--ds-font-family-accent), monospace;\n  font-size: 0.47rem;\n  letter-spacing: 0.045em;\n  text-transform: uppercase;\n  backdrop-filter: blur(8px);\n}\n\n.feed-card .feed-card__media--landscape,\n.feed-card .feed-card__media--square,\n.feed-card .feed-card__media--portrait {\n  height: auto;\n}\n\n.feed-source {\n  position: relative;\n  z-index: 2;\n}\n\n.feed-source--social {\n  display: grid;\n  gap: 11px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  background:\n    radial-gradient(circle at top right, rgba(255, 255, 255, 0.08), transparent 34%),\n    #080d17;\n  padding: 16px 17px 15px;\n}\n\n.feed-source__identity {\n  display: grid;\n  grid-template-columns: 34px minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 10px;\n}\n\n.feed-source__platform {\n  display: grid;\n  width: 34px;\n  height: 34px;\n  place-items: center;\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  border-radius: 50%;\n  background: white;\n  color: #05070b;\n  font-family: var(--ds-font-family-accent), monospace;\n  font-size: 0.82rem;\n  font-weight: 800;\n}\n\n.feed-source__account {\n  display: grid;\n  min-width: 0;\n  gap: 1px;\n}\n\n.feed-source__account strong {\n  overflow: hidden;\n  color: white;\n  font-size: 0.78rem;\n  line-height: 1.15;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.feed-source__account span,\n.feed-source__identity time {\n  color: #8997b2;\n  font-family: var(--ds-font-family-accent), monospace;\n  font-size: 0.53rem;\n  letter-spacing: 0.02em;\n}\n\n.feed-source__identity time {\n  text-align: right;\n}\n\n.feed-source p.feed-source__post-copy {\n  margin: 0;\n  color: #edf2fd;\n  font-size: 0.84rem;\n  line-height: 1.48;\n  overflow-wrap: anywhere;\n  white-space: pre-line;\n}\n\n.feed-source__link {\n  display: inline-flex;\n  width: fit-content;\n  align-items: center;\n  gap: 5px;\n  color: #8cb1ff;\n  font-size: 0.64rem;\n  font-weight: 700;\n  text-decoration: none;\n}\n\n.feed-source__link:hover {\n  color: white;\n}\n\n.feed-source__link:focus-visible,\n.feed-source__getty-credit:focus-visible {\n  border-radius: 5px;\n  outline: 2px solid var(--demo-blue-bright);\n  outline-offset: 3px;\n}\n\n.feed-source__link svg,\n.feed-source__getty-credit svg {\n  width: 13px;\n  height: 13px;\n  flex: 0 0 auto;\n}\n\n.feed-source__getty-credit {\n  position: relative;\n  z-index: 3;\n  display: flex;\n  min-width: 0;\n  align-items: center;\n  gap: 7px;\n  border-top: 1px solid rgba(134, 155, 205, 0.14);\n  border-bottom: 1px solid rgba(134, 155, 205, 0.14);\n  background: #080e1a;\n  color: #b9c4d9;\n  padding: 8px 12px;\n  font-family: var(--ds-font-family-accent), monospace;\n  font-size: 0.48rem;\n  line-height: 1.35;\n  letter-spacing: 0.025em;\n  text-decoration: none;\n}\n\n.feed-source__getty-credit > span {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.feed-source__getty-credit small {\n  margin-left: auto;\n  border: 1px solid rgba(255, 255, 255, 0.13);\n  border-radius: 999px;\n  color: #d7deec;\n  padding: 2px 5px;\n  font: inherit;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n}\n\n.feed-source__getty-credit:hover {\n  color: white;\n}\n\n.feed-source__getty-credit--compact {\n  position: absolute;\n  right: 5px;\n  bottom: 5px;\n  left: 5px;\n  gap: 4px;\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  border-radius: 6px;\n  background: rgba(3, 7, 18, 0.78);\n  color: rgba(255, 255, 255, 0.85);\n  padding: 4px 5px;\n  font-size: 0.4rem;\n  backdrop-filter: blur(8px);\n}\n\n.feed-source__getty-credit--compact svg {\n  width: 9px;\n  height: 9px;\n}\n\n.feed-card--source-official-social {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n.feed-card--source-official-social .feed-card__content {\n  background: linear-gradient(135deg, rgba(255, 255, 255, 0.035), transparent 58%);\n}\n\n.feed-card__media-wash {\n  position: absolute;\n  inset: auto 0 0;\n  height: 55%;\n  background: linear-gradient(to bottom, transparent, rgba(7, 11, 20, 0.68));\n  pointer-events: none;\n}\n\n.feed-card__play {\n  position: absolute;\n  z-index: 2;\n  inset: 50% auto auto 50%;\n  display: grid;\n  width: 58px;\n  height: 58px;\n  place-items: center;\n  border: 1px solid rgba(255, 255, 255, 0.7);\n  border-radius: 50%;\n  background: rgba(2, 6, 23, 0.52);\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.35);\n  backdrop-filter: blur(8px);\n  cursor: pointer;\n  transform: translate(-50%, -50%);\n  transition: background-color 160ms ease, transform 160ms ease;\n}\n\n.feed-card__play:hover {\n  background: rgba(28, 98, 235, 0.76);\n  transform: translate(-50%, -50%) scale(1.04);\n}\n\n.feed-card__play:focus-visible {\n  outline: 2px solid white;\n  outline-offset: 3px;\n}\n\n.feed-card__play svg {\n  width: 29px;\n  height: 29px;\n  color: white;\n}\n\n.feed-card__content {\n  position: relative;\n  z-index: 2;\n  min-width: 0;\n  padding: 17px;\n  overflow-wrap: anywhere;\n}\n\n.feed-card--has-image .feed-card__content {\n  border-top: 1px solid rgba(134, 155, 205, 0.16);\n}\n\n.feed-card__meta {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 11px;\n  color: var(--demo-soft);\n  font-family: var(--ds-font-family-accent), monospace;\n  font-size: 0.58rem;\n  letter-spacing: 0.045em;\n  text-transform: uppercase;\n}\n\n.feed-card__meta > span {\n  min-width: 0;\n}\n\n.feed-card__meta > span:last-child {\n  text-align: right;\n}\n\n.feed-card__label {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  color: color-mix(in srgb, var(--asset-accent) 78%, white);\n  font-weight: 700;\n}\n\n.feed-card__label svg {\n  width: 11px;\n  height: 11px;\n}\n\n.feed-card h3 {\n  max-width: 20ch;\n  margin: 0;\n  color: white;\n  font-size: clamp(1.22rem, 4vw, 1.58rem);\n  line-height: 1.05;\n  letter-spacing: -0.045em;\n}\n\n.feed-card p {\n  margin: 10px 0 0;\n  color: #b7c2d9;\n  font-size: 0.84rem;\n  line-height: 1.5;\n}\n\n.feed-data-visual {\n  margin-top: 16px;\n  overflow: hidden;\n  border: 1px solid rgba(134, 155, 205, 0.22);\n  border-radius: 14px;\n  background:\n    radial-gradient(circle at 85% 0, color-mix(in srgb, var(--asset-accent) 17%, transparent), transparent 42%),\n    #080f1d;\n  animation: feed-visual-in 460ms cubic-bezier(0.22, 1, 0.36, 1) both;\n}\n\n.feed-data-visual figure,\n.feed-data-visual section {\n  margin: 0;\n}\n\n.court-moment {\n  padding: 14px;\n}\n\n.court-moment figcaption,\n.game-flow figcaption,\n.lineup-stint__heading,\n.tracking-shot-profile__heading,\n.api-insight__heading {\n  display: grid;\n  gap: 3px;\n  margin-bottom: 12px;\n}\n\n.court-moment figcaption span,\n.game-flow figcaption span,\n.lineup-stint__heading span,\n.tracking-shot-profile__heading span,\n.api-insight__heading span {\n  color: color-mix(in srgb, var(--asset-accent) 76%, white);\n  font-family: var(--ds-font-family-accent), monospace;\n  font-size: 0.52rem;\n  font-weight: 700;\n  letter-spacing: 0.085em;\n}\n\n.court-moment figcaption strong,\n.game-flow figcaption strong,\n.lineup-stint__heading strong,\n.tracking-shot-profile__heading strong,\n.api-insight__heading strong {\n  color: white;\n  font-size: 0.92rem;\n  line-height: 1.2;\n  letter-spacing: -0.025em;\n}\n\n.court-moment svg,\n.game-flow svg {\n  display: block;\n  width: 100%;\n  height: auto;\n  overflow: visible;\n}\n\n.court-moment__sequence {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  row-gap: 12px;\n  margin: 0 0 12px;\n  padding: 0;\n  list-style: none;\n}\n\n.court-moment__sequence li {\n  position: relative;\n  display: grid;\n  grid-template-rows: auto 10px auto;\n  gap: 4px;\n  min-width: 0;\n  color: #aebbd1;\n  font-family: var(--ds-font-family-accent), monospace;\n  font-size: 0.56rem;\n  line-height: 1.25;\n  text-transform: uppercase;\n}\n\n.court-moment__sequence li::after {\n  position: absolute;\n  top: 19px;\n  right: 0;\n  left: 7px;\n  height: 1px;\n  background: rgba(255, 255, 255, 0.16);\n  content: \"\";\n}\n\n.court-moment__sequence li:last-child::after {\n  display: none;\n}\n\n.court-moment__sequence li:nth-child(3n)::after {\n  display: none;\n}\n\n.court-moment__sequence time {\n  color: white;\n  font-weight: 700;\n}\n\n.court-moment__sequence i {\n  z-index: 1;\n  width: 9px;\n  height: 9px;\n  border: 2px solid #8f9db6;\n  border-radius: 50%;\n  background: #080f1d;\n}\n\n.court-moment__sequence li[data-tone=\"defense\"] i {\n  border-color: #6eb7ff;\n  background: #0d4676;\n}\n\n.court-moment__sequence li[data-tone=\"score\"] i {\n  border-color: color-mix(in srgb, var(--asset-accent) 78%, white);\n  background: color-mix(in srgb, var(--asset-accent) 62%, #080f1d);\n}\n\n.court-moment__sequence span {\n  padding-right: 5px;\n}\n\n.court-moment__floor {\n  fill: #152235;\n  stroke: rgba(255, 255, 255, 0.12);\n  stroke-width: 3;\n}\n\n.court-moment__line {\n  fill: none;\n  stroke: rgba(220, 231, 250, 0.26);\n  stroke-width: 3;\n}\n\n.court-moment__backboard {\n  stroke: rgba(255, 255, 255, 0.86);\n  stroke-width: 5;\n}\n\n.court-moment__rim {\n  fill: none;\n  stroke: #ff7a45;\n  stroke-width: 5;\n}\n\n.court-moment__shot {\n  color: #c7d1e4;\n}\n\n.court-moment__shot path {\n  fill: none;\n  stroke: currentColor;\n  stroke-linecap: round;\n  stroke-width: 6;\n}\n\n.court-moment__shot circle {\n  fill: color-mix(in srgb, var(--asset-accent) 78%, #ff7a45);\n  stroke: white;\n  stroke-width: 3;\n}\n\n.court-moment__shot circle.court-moment__shot-core {\n  fill: white;\n  stroke: none;\n}\n\n.court-moment__shot text {\n  fill: #c7d1e4;\n  font-family: var(--ds-font-family-accent), monospace;\n  font-size: 17px;\n  font-weight: 700;\n  letter-spacing: 0.03em;\n  paint-order: stroke;\n  stroke: #152235;\n  stroke-width: 7px;\n  stroke-linejoin: round;\n}\n\n.court-moment__shot text.court-moment__hero-label {\n  fill: white;\n  font-size: 19px;\n  letter-spacing: 0.065em;\n}\n\n.court-moment__key {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-top: 8px;\n  color: #9eabc2;\n  font-family: var(--ds-font-family-accent), monospace;\n  font-size: 0.51rem;\n  letter-spacing: 0.035em;\n  text-transform: uppercase;\n}\n\n.court-moment__key span {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.court-moment__key i {\n  display: inline-block;\n  width: 9px;\n  height: 9px;\n}\n\n.court-moment__key-miss {\n  position: relative;\n}\n\n.court-moment__key-miss::before,\n.court-moment__key-miss::after {\n  position: absolute;\n  top: 4px;\n  left: 0;\n  width: 10px;\n  height: 1px;\n  background: #c7d1e4;\n  content: \"\";\n  transform: rotate(45deg);\n}\n\n.court-moment__key-miss::after {\n  transform: rotate(-45deg);\n}\n\n.court-moment__key-make {\n  border: 2px solid white;\n  border-radius: 50%;\n  background: color-mix(in srgb, var(--asset-accent) 78%, #ff7a45);\n}\n\n.game-flow {\n  padding: 14px 14px 12px;\n}\n\n.game-flow__quarter {\n  stroke: rgba(255, 255, 255, 0.08);\n  stroke-dasharray: 3 4;\n}\n\n.game-flow__zero {\n  stroke: rgba(255, 255, 255, 0.4);\n  stroke-width: 1.5;\n}\n\n.game-flow__area {\n  opacity: 0.78;\n}\n\n.game-flow__path {\n  fill: none;\n  stroke: color-mix(in srgb, var(--asset-accent) 84%, white);\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 3;\n}\n\n.game-flow__team {\n  fill: #8997b2;\n  font-family: var(--ds-font-family-accent), monospace;\n  font-size: 9px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n}\n\n.game-flow__annotation circle {\n  fill: var(--asset-accent);\n  stroke: white;\n  stroke-width: 2;\n}\n\n.game-flow__receipts {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  margin-top: 7px;\n  border-top: 1px solid rgba(134, 155, 205, 0.14);\n}\n\n.game-flow__receipts > div {\n  display: grid;\n  min-width: 0;\n  gap: 2px;\n  padding: 9px 6px 0;\n  text-align: center;\n}\n\n.game-flow__receipts > div + div {\n  border-left: 1px solid rgba(134, 155, 205, 0.14);\n}\n\n.game-flow__receipts span,\n.game-flow__receipts small {\n  overflow: hidden;\n  color: #8f9db6;\n  font-family: var(--ds-font-family-accent), monospace;\n  font-size: 0.43rem;\n  letter-spacing: 0.045em;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.game-flow__receipts strong {\n  color: white;\n  font-family: var(--ds-font-family-accent), monospace;\n  font-size: 0.92rem;\n}\n\n.lineup-stint,\n.tracking-shot-profile,\n.api-insight {\n  padding: 14px;\n}\n\n.lineup-stint__players {\n  display: grid;\n  gap: 5px;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.lineup-stint__players li {\n  display: grid;\n  grid-template-columns: 25px minmax(0, 1fr);\n  align-items: center;\n  gap: 9px;\n  color: #dbe3f2;\n  font-size: 0.7rem;\n}\n\n.lineup-stint__players li span {\n  display: grid;\n  width: 25px;\n  height: 25px;\n  place-items: center;\n  border: 1px solid color-mix(in srgb, var(--asset-accent) 42%, transparent);\n  border-radius: 50%;\n  background: color-mix(in srgb, var(--asset-accent) 13%, transparent);\n  color: white;\n  font-family: var(--ds-font-family-accent), monospace;\n  font-size: 0.55rem;\n  font-weight: 700;\n}\n\n.lineup-stint__stats,\n.api-insight__facts {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  margin: 13px 0 0;\n  border-top: 1px solid rgba(134, 155, 205, 0.14);\n}\n\n.lineup-stint__stats > div,\n.api-insight__facts > div {\n  display: grid;\n  gap: 2px;\n  padding: 9px 4px 0;\n  text-align: center;\n}\n\n.lineup-stint__stats dd,\n.lineup-stint__stats dt,\n.api-insight__facts dd,\n.api-insight__facts dt {\n  margin: 0;\n}\n\n.lineup-stint__stats dd,\n.api-insight__facts dd {\n  color: white;\n  font-family: var(--ds-font-family-accent), monospace;\n  font-size: 0.82rem;\n  font-weight: 700;\n}\n\n.lineup-stint__stats dt,\n.api-insight__facts dt {\n  color: #8593ad;\n  font-family: var(--ds-font-family-accent), monospace;\n  font-size: 0.43rem;\n  letter-spacing: 0.075em;\n}\n\n.impact-receipt {\n  display: grid;\n  grid-template-columns: 108px minmax(0, 1fr);\n  gap: 13px;\n  padding: 14px;\n}\n\n.impact-receipt__hero {\n  display: grid;\n  align-content: center;\n  border-right: 1px solid rgba(134, 155, 205, 0.18);\n  padding-right: 13px;\n}\n\n.impact-receipt__hero span {\n  color: #acb8cd;\n  font-size: 0.61rem;\n  line-height: 1.25;\n}\n\n.impact-receipt__hero strong {\n  color: white;\n  font-family: var(--ds-font-family-accent), monospace;\n  font-size: 2.7rem;\n  line-height: 0.98;\n  letter-spacing: -0.08em;\n}\n\n.impact-receipt__hero small {\n  color: color-mix(in srgb, var(--asset-accent) 76%, white);\n  font-family: var(--ds-font-family-accent), monospace;\n  font-size: 0.43rem;\n  letter-spacing: 0.075em;\n}\n\n.impact-receipt__route {\n  display: grid;\n  gap: 6px;\n}\n\n.impact-receipt__route > div {\n  display: grid;\n  grid-template-columns: 8px 1fr auto;\n  align-items: center;\n  gap: 7px;\n  color: #9eabc2;\n  font-family: var(--ds-font-family-accent), monospace;\n  font-size: 0.5rem;\n}\n\n.impact-receipt__route i {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: var(--asset-accent);\n  box-shadow: 0 0 0 3px color-mix(in srgb, var(--asset-accent) 16%, transparent);\n}\n\n.impact-receipt__route strong {\n  color: white;\n}\n\n.impact-receipt p {\n  grid-column: 1 / -1;\n  margin-top: 0;\n  font-size: 0.69rem;\n}\n\n.insight-receipt {\n  padding: 14px;\n}\n\n.insight-receipt__heading,\n.insight-receipt__footer,\n.tracking-shot-profile__identity {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.insight-receipt__heading span,\n.tracking-shot-profile__identity span {\n  color: #b8c3d8;\n  font-size: 0.66rem;\n}\n\n.insight-receipt__heading strong {\n  color: white;\n  font-family: var(--ds-font-family-accent), monospace;\n  font-size: 1.25rem;\n}\n\n.insight-receipt__attempts {\n  display: grid;\n  grid-template-columns: repeat(8, 1fr);\n  gap: 5px;\n  margin: 11px 0;\n}\n\n.insight-receipt__attempts i {\n  aspect-ratio: 1;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.04);\n}\n\n.insight-receipt__attempts i.is-made {\n  border-color: color-mix(in srgb, var(--asset-accent) 72%, white);\n  background: var(--asset-accent);\n}\n\n.insight-receipt__footer {\n  color: #8f9db6;\n  font-family: var(--ds-font-family-accent), monospace;\n  font-size: 0.5rem;\n  letter-spacing: 0.045em;\n}\n\n.insight-receipt__footer strong {\n  color: white;\n}\n\n.tracking-shot-profile__players {\n  display: grid;\n  gap: 13px;\n}\n\n.tracking-shot-profile__identity {\n  margin-bottom: 5px;\n  font-family: var(--ds-font-family-accent), monospace;\n  font-size: 0.51rem;\n}\n\n.tracking-shot-profile__identity strong {\n  color: white;\n  font-size: 0.56rem;\n}\n\n.tracking-shot-profile__bar {\n  height: 9px;\n  overflow: hidden;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.06);\n}\n\n.tracking-shot-profile__bar > i {\n  display: block;\n  height: 100%;\n  overflow: hidden;\n  border: 1px solid color-mix(in srgb, var(--profile-color) 48%, transparent);\n  border-radius: inherit;\n  background: color-mix(in srgb, var(--profile-color) 13%, transparent);\n}\n\n.tracking-shot-profile__bar span {\n  display: block;\n  height: 100%;\n  border-radius: inherit;\n  background: var(--profile-color);\n}\n\n.tracking-shot-profile > p,\n.api-insight > p {\n  margin-top: 12px;\n  font-size: 0.69rem;\n}\n\n.api-insight__facts {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n@keyframes feed-visual-in {\n  from {\n    opacity: 0;\n    transform: translateY(8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.feed-card__stats {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  margin: 15px 0 0;\n  border-top: 1px solid rgba(134, 155, 205, 0.14);\n  border-bottom: 1px solid rgba(134, 155, 205, 0.14);\n}\n\n.feed-card__stats > div {\n  display: grid;\n  gap: 2px;\n  padding: 11px 9px;\n  text-align: center;\n}\n\n.feed-card__stats > div + div {\n  border-left: 1px solid rgba(134, 155, 205, 0.14);\n}\n\n.feed-card__stats dd,\n.feed-card__stats dt {\n  margin: 0;\n}\n\n.feed-card__stats dd {\n  color: white;\n  font-family: var(--ds-font-family-accent), monospace;\n  font-size: 1.05rem;\n  font-weight: 700;\n  letter-spacing: -0.04em;\n}\n\n.feed-card__stats dt {\n  color: var(--demo-soft);\n  font-family: var(--ds-font-family-accent), monospace;\n  font-size: 0.52rem;\n  letter-spacing: 0.08em;\n}\n\n.feed-card__caption {\n  margin-top: 13px;\n  border-left: 2px solid var(--asset-accent);\n  color: #d4dcef;\n  padding-left: 10px;\n  font-size: 0.71rem;\n  font-style: italic;\n}\n\n.feed-card__action {\n  display: flex;\n  min-height: 28px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-top: 15px;\n  color: white;\n  font-size: 0.72rem;\n  font-weight: 700;\n}\n\n.feed-card__action--button {\n  width: 100%;\n  border: 0;\n  background: transparent;\n  padding: 0;\n  text-align: left;\n  cursor: pointer;\n}\n\n.feed-card__action--button:hover > span:first-child {\n  color: var(--demo-blue-bright);\n}\n\n.feed-card__action--button:focus-visible {\n  border-radius: 5px;\n  outline: 2px solid var(--demo-blue-bright);\n  outline-offset: 4px;\n}\n\n.feed-card__action > span:first-child {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n}\n\n.feed-card__action svg {\n  width: 15px;\n  height: 15px;\n  color: color-mix(in srgb, var(--asset-accent) 78%, white);\n}\n\n.feed-card__duration {\n  color: var(--demo-soft);\n  font-family: var(--ds-font-family-accent), monospace;\n  font-size: 0.6rem;\n  font-weight: 400;\n}\n\n.feed-card--alert {\n  border-color: color-mix(in srgb, var(--asset-accent) 45%, transparent);\n  background:\n    linear-gradient(100deg, color-mix(in srgb, var(--asset-accent) 18%, transparent), transparent 58%),\n    var(--demo-card);\n}\n\n.feed-card--alert::before {\n  position: absolute;\n  inset: 0 auto 0 0;\n  width: 3px;\n  background: var(--asset-accent);\n  content: \"\";\n}\n\n.feed-card--alert h3 {\n  max-width: 18ch;\n  font-size: 1.45rem;\n}\n\n.feed-card--catch-up {\n  border-color: rgba(79, 131, 255, 0.36);\n  background:\n    linear-gradient(145deg, rgba(28, 98, 235, 0.18), transparent 62%),\n    #0c1424;\n}\n\n.feed-card--recap {\n  border-color: rgba(253, 185, 39, 0.3);\n}\n\n.feed-card--gallery {\n  border-color: rgba(79, 131, 255, 0.34);\n}\n\n.feed-card--gallery .feed-card__content {\n  border-top: 1px solid rgba(134, 155, 205, 0.16);\n}\n\n.feed-card--incoming {\n  display: grid;\n  min-height: 142px;\n  grid-template-columns: 54px 1fr;\n  align-items: center;\n  gap: 14px;\n  padding: 18px;\n  border-color: rgba(79, 131, 255, 0.36);\n  background: rgba(28, 98, 235, 0.08);\n}\n\n.incoming-signal {\n  position: relative;\n  display: grid;\n  width: 52px;\n  height: 52px;\n  place-items: center;\n}\n\n.incoming-signal span {\n  position: absolute;\n  border: 1px solid rgba(119, 163, 255, 0.8);\n  border-radius: 50%;\n  animation: signal-pulse 1.25s ease-out infinite;\n}\n\n.incoming-signal span:nth-child(1) {\n  width: 12px;\n  height: 12px;\n  background: var(--demo-blue);\n}\n\n.incoming-signal span:nth-child(2) {\n  width: 30px;\n  height: 30px;\n  animation-delay: 120ms;\n}\n\n.incoming-signal span:nth-child(3) {\n  width: 50px;\n  height: 50px;\n  animation-delay: 240ms;\n}\n\n.incoming-copy {\n  display: grid;\n  gap: 9px;\n}\n\n.skeleton-line {\n  display: block;\n  height: 9px;\n  border-radius: 4px;\n  background: linear-gradient(\n    90deg,\n    rgba(124, 145, 193, 0.12),\n    rgba(119, 163, 255, 0.34),\n    rgba(124, 145, 193, 0.12)\n  );\n  background-size: 220% 100%;\n  animation: skeleton-shimmer 1.2s linear infinite;\n}\n\n.skeleton-line--eyebrow {\n  width: 34%;\n  height: 6px;\n}\n\n.skeleton-line--title {\n  width: 88%;\n  height: 15px;\n}\n\n.skeleton-line--body {\n  width: 68%;\n}\n\n.intelligence-card {\n  padding: 20px;\n}\n\n.intelligence-card h2 {\n  max-width: 10ch;\n  font-size: 1.6rem;\n  line-height: 1.02;\n}\n\n.intelligence-card__now {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  margin-top: 19px;\n  border-top: 1px solid var(--demo-line);\n  padding-top: 17px;\n}\n\n.intelligence-card__pulse {\n  width: 8px;\n  height: 8px;\n  flex: 0 0 auto;\n  margin-top: 5px;\n  border-radius: 50%;\n  background: #36d27e;\n  box-shadow: 0 0 0 5px rgba(54, 210, 126, 0.1);\n}\n\n.intelligence-card__now div {\n  display: grid;\n  gap: 4px;\n}\n\n.intelligence-card__now small {\n  color: var(--demo-soft);\n  font-family: var(--ds-font-family-accent), monospace;\n  font-size: 0.58rem;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.intelligence-card__now strong {\n  color: #dbe4f7;\n  font-size: 0.8rem;\n  line-height: 1.42;\n}\n\n.capability-stack {\n  display: grid;\n  gap: 8px;\n}\n\n.capability {\n  display: grid;\n  grid-template-columns: 33px 1fr;\n  gap: 10px;\n  border: 1px solid rgba(134, 155, 205, 0.13);\n  border-radius: 10px;\n  background: rgba(8, 16, 31, 0.46);\n  padding: 13px;\n}\n\n.capability > span {\n  display: grid;\n  width: 31px;\n  height: 31px;\n  place-items: center;\n  border: 1px solid rgba(79, 131, 255, 0.26);\n  border-radius: 8px;\n  background: rgba(28, 98, 235, 0.1);\n  color: var(--demo-blue-bright);\n}\n\n.capability svg {\n  width: 15px;\n  height: 15px;\n}\n\n.capability h3,\n.capability p {\n  margin: 0;\n}\n\n.capability h3 {\n  font-size: 0.78rem;\n}\n\n.capability p {\n  margin-top: 4px;\n  color: var(--demo-soft);\n  font-size: 0.7rem;\n  line-height: 1.42;\n}\n\n.feed-items-shell {\n  min-height: 100dvh;\n}\n\n.feed-items-hero {\n  display: grid;\n  width: min(100%, 1440px);\n  grid-template-columns: minmax(0, 1fr) minmax(340px, 0.58fr);\n  align-items: end;\n  gap: clamp(40px, 8vw, 120px);\n  margin: 0 auto;\n  padding: clamp(68px, 8vw, 118px) clamp(24px, 5vw, 72px) clamp(72px, 9vw, 132px);\n}\n\n.feed-items-hero__copy {\n  max-width: 780px;\n}\n\n.feed-items-hero h1 {\n  max-width: 12ch;\n  margin: 0;\n  font-size: clamp(3.2rem, 7vw, 7rem);\n  font-weight: 700;\n  line-height: 0.9;\n  letter-spacing: -0.065em;\n}\n\n.feed-items-hero__copy > p {\n  max-width: 660px;\n  margin: 26px 0 0;\n  color: #b7c2d9;\n  font-size: clamp(1rem, 1.6vw, 1.3rem);\n  line-height: 1.55;\n}\n\n.feed-items-hero__link {\n  display: inline-flex;\n  align-items: center;\n  gap: 9px;\n  margin-top: 28px;\n  color: #dce6ff;\n  font-size: 0.86rem;\n  font-weight: 700;\n}\n\n.feed-items-hero__link:hover {\n  color: white;\n}\n\n.feed-items-hero__link:focus-visible {\n  border-radius: 6px;\n  outline: 2px solid var(--demo-blue-bright);\n  outline-offset: 5px;\n}\n\n.feed-items-hero__link svg {\n  width: 17px;\n  height: 17px;\n}\n\n.feed-items-hero__facts {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  margin: 0;\n  border-top: 1px solid var(--demo-line);\n  border-bottom: 1px solid var(--demo-line);\n}\n\n.feed-items-hero__facts > div {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  padding: 24px 14px;\n  text-align: center;\n}\n\n.feed-items-hero__facts > div + div {\n  border-left: 1px solid var(--demo-line);\n}\n\n.feed-items-hero__facts dd,\n.feed-items-hero__facts dt {\n  margin: 0;\n}\n\n.feed-items-hero__facts dd {\n  order: -1;\n  font-family: var(--ds-font-family-accent), monospace;\n  font-size: clamp(1.5rem, 3vw, 2.5rem);\n  font-weight: 700;\n}\n\n.feed-items-hero__facts dt {\n  margin-top: 6px;\n  color: var(--demo-soft);\n  font-size: 0.68rem;\n  line-height: 1.35;\n}\n\n.feed-items-sections {\n  border-top: 1px solid var(--demo-line);\n}\n\n.feed-items-section {\n  width: min(100%, 1440px);\n  margin: 0 auto;\n  padding: clamp(68px, 8vw, 112px) clamp(24px, 5vw, 72px);\n}\n\n.feed-items-section + .feed-items-section {\n  border-top: 1px solid var(--demo-line);\n}\n\n.feed-items-section__header {\n  display: grid;\n  grid-template-columns: 58px minmax(0, 760px);\n  gap: 24px;\n  margin-bottom: clamp(48px, 7vw, 88px);\n}\n\n.feed-items-section__number {\n  color: rgba(119, 163, 255, 0.58);\n  font-family: var(--ds-font-family-accent), monospace;\n  font-size: 0.78rem;\n  letter-spacing: 0.12em;\n}\n\n.feed-items-section__header h2 {\n  margin: 0;\n  font-size: clamp(2.2rem, 4.7vw, 4.8rem);\n  line-height: 0.96;\n  letter-spacing: -0.055em;\n}\n\n.feed-items-section__header p {\n  max-width: 680px;\n  margin: 20px 0 0;\n  color: var(--demo-soft);\n  font-size: clamp(0.98rem, 1.5vw, 1.18rem);\n  line-height: 1.58;\n}\n\n.feed-item-families {\n  display: grid;\n  gap: clamp(64px, 9vw, 120px);\n}\n\n.feed-item-family__header {\n  display: grid;\n  max-width: 760px;\n  grid-template-columns: 42px minmax(0, 1fr);\n  gap: 16px;\n  margin-bottom: 30px;\n}\n\n.feed-item-family__header > span {\n  display: grid;\n  width: 42px;\n  height: 42px;\n  place-items: center;\n  border: 1px solid rgba(79, 131, 255, 0.3);\n  border-radius: 11px;\n  background: rgba(28, 98, 235, 0.12);\n  color: var(--demo-blue-bright);\n}\n\n.feed-item-family__header svg {\n  width: 18px;\n  height: 18px;\n}\n\n.feed-item-family__header h3,\n.feed-item-family__header p {\n  margin: 0;\n}\n\n.feed-item-family__header h3 {\n  font-size: clamp(1.55rem, 2.6vw, 2.45rem);\n  line-height: 1.05;\n  letter-spacing: -0.04em;\n}\n\n.feed-item-family__header p {\n  margin-top: 8px;\n  color: var(--demo-soft);\n  font-size: 0.9rem;\n  line-height: 1.55;\n}\n\n.feed-item-family__examples {\n  display: grid;\n  grid-template-columns: repeat(\n    auto-fit,\n    minmax(min(100%, 380px), 440px)\n  );\n  align-items: start;\n  justify-content: start;\n  gap: clamp(22px, 3vw, 36px);\n}\n\n.feed-item-example {\n  min-width: 0;\n}\n\n.feed-item-example__context {\n  min-height: 126px;\n  padding: 0 2px 14px;\n}\n\n.feed-item-example__context > strong {\n  display: block;\n  min-height: 18px;\n  color: #dce6ff;\n  font-size: 0.74rem;\n  letter-spacing: 0.01em;\n}\n\n.feed-item-example__context dl {\n  display: grid;\n  gap: 7px;\n  margin: 12px 0 0;\n}\n\n.feed-item-example__context dl > div {\n  display: grid;\n  grid-template-columns: 76px minmax(0, 1fr);\n  gap: 10px;\n  align-items: baseline;\n}\n\n.feed-item-example__context dt,\n.feed-item-example__context dd {\n  margin: 0;\n}\n\n.feed-item-example__context dt {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  color: #7584a5;\n  font-family: var(--ds-font-family-accent), monospace;\n  font-size: 0.55rem;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n}\n\n.feed-item-example__context dt svg {\n  width: 10px;\n  height: 10px;\n}\n\n.feed-item-example__context dd {\n  color: var(--demo-soft);\n  font-size: 0.7rem;\n  line-height: 1.4;\n}\n\n.feed-items-shell .feed-card,\n.feed-items-shell .feed-data-visual {\n  animation: none;\n  will-change: auto;\n}\n\n.feed-item-rules {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  border-top: 1px solid var(--demo-line);\n  border-bottom: 1px solid var(--demo-line);\n}\n\n.feed-item-rules > section {\n  display: grid;\n  min-width: 0;\n  grid-template-columns: 38px minmax(0, 1fr);\n  gap: 16px;\n  padding: 28px 24px;\n}\n\n.feed-item-rules > section:nth-child(even) {\n  border-left: 1px solid var(--demo-line);\n}\n\n.feed-item-rules > section:nth-child(n + 3) {\n  border-top: 1px solid var(--demo-line);\n}\n\n.feed-item-rules > section > span {\n  color: var(--demo-blue-bright);\n  font-family: var(--ds-font-family-accent), monospace;\n  font-size: 0.7rem;\n}\n\n.feed-item-rules h4,\n.feed-item-rules p {\n  margin: 0;\n}\n\n.feed-item-rules h4 {\n  font-size: 1rem;\n}\n\n.feed-item-rules p {\n  margin-top: 7px;\n  color: var(--demo-soft);\n  font-size: 0.82rem;\n  line-height: 1.52;\n}\n\n@keyframes card-enter {\n  from {\n    opacity: 0;\n    transform: translateY(-16px) scale(0.985);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@keyframes signal-pulse {\n  0% {\n    opacity: 0.2;\n    transform: scale(0.78);\n  }\n  48% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0.15;\n    transform: scale(1.08);\n  }\n}\n\n@keyframes skeleton-shimmer {\n  to {\n    background-position: -220% 0;\n  }\n}\n\n@keyframes orbit {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@media (min-width: 821px) {\n  .feed-stage {\n    min-height: calc(100dvh - 94px);\n  }\n\n  .game-phone {\n    height: auto;\n    min-height: calc(100dvh - 118px);\n    overflow: clip;\n  }\n\n  .game-phone__header {\n    position: sticky;\n    top: 64px;\n  }\n\n  .game-feed {\n    overflow-x: clip;\n    overflow-y: visible;\n    overscroll-behavior: auto;\n    touch-action: auto;\n  }\n}\n\n@media (min-width: 821px) and (max-height: 860px) {\n  .presenter-rail {\n    position: static;\n    top: auto;\n  }\n}\n\n@media (max-width: 1180px) {\n  .demo-layout {\n    grid-template-columns: minmax(250px, 310px) minmax(400px, 480px);\n  }\n\n  .presenter-rail--right {\n    position: static;\n    top: auto;\n    grid-column: 2;\n  }\n}\n\n@media (max-width: 820px) {\n  .topbar {\n    padding: 0 16px;\n  }\n\n  .topbar [data-slot=\"badge\"] {\n    display: none;\n  }\n\n  .site-nav {\n    position: static;\n    margin-left: auto;\n    transform: none;\n  }\n\n  .demo-layout {\n    grid-template-columns: minmax(0, 520px);\n    gap: 24px;\n    padding: 24px 14px 60px;\n  }\n\n  .feed-stage {\n    grid-row: 1;\n    grid-column: 1;\n  }\n\n  .presenter-rail--right {\n    position: static;\n    top: auto;\n    grid-row: 2;\n    grid-column: 1;\n  }\n\n  .presenter-rail--left {\n    display: none;\n  }\n\n  .game-phone__mobile-controls {\n    display: block;\n    border-top: 1px solid rgba(134, 155, 205, 0.14);\n    background: rgba(5, 9, 18, 0.84);\n    padding: 10px 12px 12px;\n  }\n\n  .game-selector h1 {\n    max-width: none;\n    font-size: 2.2rem;\n  }\n\n  .feed-items-hero {\n    grid-template-columns: 1fr;\n  }\n\n  .feed-items-hero__facts {\n    max-width: 560px;\n  }\n\n}\n\n@media (max-width: 600px) {\n  .topbar {\n    min-height: 58px;\n  }\n\n  .brand__product,\n  .brand__divider {\n    display: none;\n  }\n\n  .brand__logo {\n    width: 108px;\n    height: auto;\n  }\n\n  .site-nav a {\n    padding: 6px 9px;\n    font-size: 0.67rem;\n  }\n\n  .topbar [data-slot=\"badge\"] {\n    padding-right: 7px;\n    padding-left: 7px;\n    font-size: 0.58rem;\n  }\n\n  .demo-layout {\n    min-height: calc(100dvh - 58px);\n    padding: 18px 0 50px;\n  }\n\n  .presenter-rail {\n    padding: 0 14px;\n  }\n\n  .game-selector h1 {\n    font-size: 2rem;\n  }\n\n  .feed-stage__label {\n    margin: 0 16px 8px;\n  }\n\n  .feed-stage__label span:last-child {\n    display: none;\n  }\n\n  .game-phone {\n    height: 720px;\n    border-right: 0;\n    border-left: 0;\n    border-radius: 0;\n    box-shadow: none;\n  }\n\n  .game-feed {\n    padding: 12px;\n  }\n\n  .scoreboard {\n    gap: 8px;\n    padding-right: 14px;\n    padding-left: 14px;\n  }\n\n  .team-score {\n    gap: 7px;\n  }\n\n  .team-score__mark {\n    width: 33px;\n    height: 33px;\n    border-radius: 8px;\n  }\n\n  .team-score__identity strong {\n    font-size: 1.45rem;\n  }\n\n  .game-phone__competition,\n  .game-phone__beat {\n    padding-right: 14px;\n    padding-left: 14px;\n  }\n\n  .feed-card__media {\n    height: 200px;\n  }\n\n  .feed-card--moment .feed-card__media,\n  .feed-card--recap .feed-card__media,\n  .feed-card--highlight .feed-card__media {\n    height: 225px;\n  }\n\n  .court-moment__sequence {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .court-moment__sequence li {\n    font-size: 0.58rem;\n  }\n\n  .court-moment__sequence li:nth-child(3n)::after {\n    display: block;\n  }\n\n  .court-moment__sequence li:nth-child(2n)::after,\n  .court-moment__sequence li:last-child::after {\n    display: none;\n  }\n\n  .feed-items-hero {\n    padding: 52px 18px 70px;\n  }\n\n  .feed-items-hero h1 {\n    font-size: clamp(3rem, 16vw, 4.5rem);\n  }\n\n  .feed-items-hero__facts > div {\n    padding: 18px 8px;\n  }\n\n  .feed-items-section {\n    padding: 64px 14px;\n  }\n\n  .feed-items-section__header {\n    grid-template-columns: 1fr;\n    gap: 14px;\n  }\n\n  .feed-item-family__header {\n    grid-template-columns: 36px minmax(0, 1fr);\n    gap: 12px;\n  }\n\n  .feed-item-family__header > span {\n    width: 36px;\n    height: 36px;\n    border-radius: 9px;\n  }\n\n  .feed-item-example__context {\n    min-height: 0;\n  }\n\n  .feed-item-rules {\n    grid-template-columns: 1fr;\n  }\n\n  .feed-item-rules > section {\n    padding: 24px 8px;\n  }\n\n  .feed-item-rules > section:nth-child(even) {\n    border-left: 0;\n  }\n\n  .feed-item-rules > section + section {\n    border-top: 1px solid var(--demo-line);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  html {\n    scroll-behavior: auto;\n  }\n\n  *,\n  *::before,\n  *::after {\n    scroll-behavior: auto !important;\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n  }\n}\n\n@keyframes storyteller-spin {\n  to {\n    transform: rotate(1turn);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
